//se modifico
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Button, FormGroup, Row, Col } from "reactstrap";
import Modal from "@material-ui/core/Modal";
import ModalMessage from "../../shared/components/Modal";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import {
  DatePicker,
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
  TimePicker,
} from "@material-ui/pickers";
import clsx from "clsx";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
// pick a date util library
import MomentUtils from "@date-io/moment";
import "moment/locale/es";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import history from "../../history";
import Checkbox from "@material-ui/core/Checkbox";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import CalendarTodayRounded from "@material-ui/icons/CalendarTodayRounded";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import SaveIcon from "@material-ui/icons/Save";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import { splitNames } from "../Utils/Patient";

//import FallingRisk from '../../containers/Admissions/SearchAdmissions/components/FallingRisk';
import FallingRisksModal from "./FallingRisksModal";
import EspecialRequirementsModal from "./EspecialRequirementsModal";
import { PatientSends } from "./PatientSends";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faDisease } from "@fortawesome/free-solid-svg-icons";
import Spinner from "react-bootstrap/Spinner";
//Personalizacion de Date Time Pickers
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";

import ModalChangeAppointmentDate from "./ModalChangeAppointmentDate";
import ModalAdditionalAppointment from "./ModalAdditionalAppointment";
import { calculateAge, calculateAgeParse } from "../Utils/Patient";
import BlockIcon from "@material-ui/icons/Block";
import AlergiesListToShow from "../Patient/DisplayPatientInformation/components/alergies/components/AlergiesListToShow";
import StagesManagement from "./StagesManagement/StagesManagement";
import ModalSelectRoom from "./ModalSelectRoom";

const defaultMaterialTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#3EA3FC",
      contrastText: "#fff",
    },
  },
});

const styles = (theme) => ({
  disabled: {
    color: "rgba(0, 0, 0, 0.87)",
    width: "175px",
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  getContentAnchorEl: null,
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 650,
    },
  },
};

const MedicalCheckbox = withStyles({
  root: {
    "&$checked": {
      color: "#4ce1b6",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const CHIP_MAX_WIDTH = 600;
const CHIP_ICON_WIDTH = 30;

const EllipsisText = (props) => {
  const { children } = props;

  return (
    <div
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: CHIP_MAX_WIDTH - CHIP_ICON_WIDTH,
      }}
    >
      {children}
    </div>
  );
};

const useStyles = makeStyles({
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "#f5f8fa",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: "rgba(206,217,224,.5)",
    },
  },
  checkedIcon: {
    backgroundColor: "#137cbd",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  },
});

// Inspired by blueprintjs
function StyledRadio(props) {
  const classes = useStyles();
  return (
    <Radio
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  );
}

const filterOptions = createFilterOptions({
  limit: 20,
});

class AppointmentAssignmentModal extends Component {
  static propTypes = {
    handlerClose: PropTypes.func.isRequired,
    openEvent: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      tiposConsulta: [],
      openEvent: false,
      professional: null,
      professionals: [],
      date: new Date(),
      dateEnable: true,
      birthday: null,
      possibleDate: null,
      solicitDate: new Date(),
      costumer: null, //terceroId
      costumer_data: null, //tercero
      costumer_name: "",
      plans: [],
      plan: null,
      activity: null,
      activitiesAppointment: [],
      activities: [],
      observation: "",
      document_number: "",
      id_patient: null,
      history: null,
      name: "",
      cellphone: "",
      telephone1: "",
      telephone2: "",
      gender: "",
      email: "",
      serter: [],
      errors: {},
      error: true,
      loadAppointment: false,
      openAlert: false,
      modalAlert: { title: "", color: "", message: "" },
      id_appointment: "",
      priority: "",
      load: false,
      serve: [],
      servicios: [],
      labsResult: [],
      labs: [],
      forma_cita: 1 /*1-Tercero (Cita Normal), 2-Patrocinador (Estudio Clinico) */,
      estudios_clinicos: [],
      estudio_clinico: null,
      visitas: [],
      visita: null,
      departments: [],
      cities: [],
      countries: [],
      country: "00038",
      department: "",
      city: "",
      address: "",
      id_city: "",
      typeDate: "",
      typeOfDocument: "",
      patienteExist: false,
      cancelObservation: "",
      cancelType: "",
      openCancel: false,
      weight: "",
      height: "",
      imc: "",
      zone: "U",
      updateData: false,
      updateDataIMC: false,
      disableInput: false,
      disableInputServ: false,
      typeConsult: "",
      regime: "",
      etnia: "",
      race: "",
      typeBlood: "",
      id_history: "",
      civilStatus: "",
      last_name: "",
      modalReqEsp: false,
      modalFallingRisks: false,
      listTipos: JSON.parse(sessionStorage.getItem("centroTipos")),
      fallingRiskPatient: null,
      requerimientos_especiales: {},
      closeModalRisk: false,
      caidas: {},
      thirdPlusContract: [],
      third_ContractSelected: "",
      plansFromContract: [],
      planFromContractSelected: "",
      third: [],
      thirdId: "",
      servicesFromPlan: [],
      servicesAppointment: [],
      openModalChangingAppointment: false,
      serviceChangeDate: null,
      openModalAdditionalAppointment: false,
      activitiesPriceList: [],
      confirmedAdditionalAppointments: [],
      menopause: null,
      menstruationPatientDate: null,
      planningMethod: null,
      pregnancyTest: null,
      womanInformationEdit: false,
      nameInitialPhase: null,
      firstAppointment: "No",
      ageLetters: "",
      exemptFromPayment: false,
      loadingProcess: false,
      loadingAutocomplete: false,
      openModalAlergies: false,
      showFeminineInfo: false,
      showSpecialReq: false,
      showFallingRisks: false,
      user: JSON.parse(sessionStorage.getItem("usuario")),
      appointmentExist: false,
      userAppoint: "",
      appointsmentsDate: moment(new Date()),
      observationFieldEdit: false,
      verifyPaymentServiceControl: false, //Opciones Parametrización: verifica cobro de Consulta de control si es true las cobra
      numDaysToCheckPayment: null,
      workplaceSelected: null,
      workplaces: [],
      dayStages: [],
      servicesSelectedDuration: 0,
      manageStagesAgenda: false,
      idStagesAgenda: [this.props.dataEvent.id], //id de la jornada de la cita, cuando se selecciona más de una jornada
      isModalOpenRoom: false,
      room: "",
      listProfesionales: [],
      showHistoryMedico: false,
      poblacionVulnerable: "",
      poblaciones: [],
    };
  }

  loadWorkplaces = async () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "sedes/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
          this.setState({ workplaces: data });
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadJornadasSegmentsByDay = async (id_agenda, dia) => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        `agenda/listar-jornadas-por-dia?id_agenda=${id_agenda}&dia=${dia}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error(response.json());
        }
      })
      .then((data) => {
        this.setState({ dayStages: this.manageStages(data) });
      })
      .catch((error) => {
        console.error("Error:", error);
        this.setState({ dayStages: [] });
      });
  };

  loadTipoConsulta = () => {
    return new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_PUBLIC_URL + "admision/listar-tipo-consulta",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({ tiposConsulta: data });
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve([]);
        });
    });
  };

  manageStages = (data) => {
    let findStageDataEvent = data.find(
      (stage) => stage.id === this.props.dataEvent.id
    );
    let findIdxStageDataEvent = data.findIndex(
      (stage) => stage.id === this.props.dataEvent.id
    );
    let intervalMin = findStageDataEvent
      ? findStageDataEvent.intervalo
      : this.props.dataEvent.intervalo; //intervalo de la agenda
    const totalminutesToSelect = 120 - intervalMin;
    const totalStagesToSelect = Math.ceil(totalminutesToSelect / intervalMin); //cantidad de jornadas a mostrar
    let arrayToShow = [findStageDataEvent];
    let acc = parseInt(intervalMin);
    let contPrev = parseInt(totalStagesToSelect / 2);
    let contNext = totalStagesToSelect - contPrev;
    let isItAvailablePrev = true;
    let numberPrevToShow = 0;
    let prevIndex = findIdxStageDataEvent - 1;
    let isItAvailableNext = true;
    let numberNextToShow = 0;
    let nextIndex = findIdxStageDataEvent + 1;

    while (isItAvailablePrev && contPrev !== 0) {
      if (data[prevIndex] && data[prevIndex].priority === "Disponible") {
        acc += data[prevIndex].intervalo;
        numberPrevToShow += 1;
        prevIndex--;
        contPrev--;
      } else {
        isItAvailablePrev = false;
        if (contPrev !== 0) {
          contNext += contPrev;
        }
      }
    }

    while (isItAvailableNext && contNext !== 0) {
      if (data[nextIndex] && data[nextIndex].priority === "Disponible") {
        acc += data[nextIndex].intervalo;
        numberNextToShow += 1;
        nextIndex++;
        contNext--;
      } else {
        isItAvailableNext = false;
      }
    }

    for (let i = 0; i < numberPrevToShow; i++) {
      arrayToShow.unshift(data[findIdxStageDataEvent - (i + 1)]);
    }
    for (let i = 0; i < numberNextToShow; i++) {
      arrayToShow.push(data[findIdxStageDataEvent + (i + 1)]);
    }

    let findIdDataEvent = arrayToShow.findIndex(
      (stage) => stage.id === this.props.dataEvent.id
    );

    let arrayStages = arrayToShow.map((stage, idx) => {
      if (idx === findIdDataEvent) {
        stage.disabled = true;
      } else {
        stage.disabled = true;
      }
      if (findIdDataEvent - 1 === idx) {
        stage.disabled = false;
      }
      if (findIdDataEvent + 1 === idx) {
        stage.disabled = false;
      }
      return stage;
    });
    return arrayStages;
  };

  handlePoblacionVulnerable = (poblacion) => {
    this.setState({ poblacionVulnerable: poblacion });
  };

  handleRoomSave = (roomId) => {
    this.setState({ room: roomId });
  };

  handlerIdsStagesSelection = (id, action) => {
    if (action === "ADD") {
      this.setState({ idStagesAgenda: [...this.state.idStagesAgenda, id] });
    } else {
      let newIds = this.state.idStagesAgenda.filter((stages) => stages !== id);
      this.setState({ idStagesAgenda: newIds });
    }
  };

  cleanDataPregantInformation = () => {
    this.setState({
      menopause: null,
      menstruationPatientDate: null,
      planningMethod: null,
      pregnancyTest: null,
    });
  };

  handlerCloseOpenModalChangingAppointment = (op) => {
    this.setState({ openModalChangingAppointment: op });
  };

  handlerCloseEvent = (close) => {
    this.setState({ openEvent: close });
  };

  handlerProfessional = (professional) => {
    this.setState({ professional: professional });
  };

  handlerDate = (date) => {
    this.setState({ date: date });
  };

  handlerBirthDate = (birthday) => {
    this.setState({ birthday: birthday }, () =>
      this.setState({ ageLetters: calculateAgeParse(birthday) })
    );
  };

  handlerGender = (gender) => {
    this.setState({ gender: gender }, () => {
      this.cleanDataPregantInformation();
    });
  };

  handlerCostumer = (costumer) => {
    this.setState({
      costumer_data: null,
      costumer: null,
      plans: [],
      plan: null,
      activity: null,
      activities: [],
      estudios_clinicos: [],
      estudio_clinico: null,
      visitas: [],
      visita: null,
    });

    if (costumer != null) {
      this.setState({ costumer_data: costumer });
      this.setState({ costumer: costumer.id_tercero });

      //Esteban Londoño Ospina 17/09/2021
      //Dependiendo del tipo de tercero se cambia la forma de crear la cita medica, si cita normal o de estudio clinico
      switch (parseInt(costumer.tipo)) {
        case 1: //Tercero Normal
          this.setState({ forma_cita: 1 });
          this.loadPlans(costumer.id_tercero).then((plans) => {
            this.setState({ plans: plans, activities: [], activity: null });
          });
          break;
        case 2: //Patrocinador
          this.setState({ forma_cita: 2 });
          this.loadClinicalStudio(costumer.id_tercero);
          break;
        default:
          this.setState({ forma_cita: 1 });
          this.loadPlans(costumer.id_tercero).then((plans) => {
            this.setState({ plans: plans, activities: [], activity: null });
          });
          break;
      }
    }
  };

  handlerThird_contract = (third) => {
    this.setState({
      costumer_data: null,
      costumer: null,
      plans: [],
      plan: null,
      activity: null,
      activities: [],
      estudios_clinicos: [],
      estudio_clinico: null,
      visitas: [],
      visita: null,
      activitiesAppointment: [],
    });
    //this.setState({ third_ContractSelected: third });
    if (third !== null) {
      this.setState({ costumer: third.id_tercero, costumer_data: third });
      let contractId = parseInt(third.id_contrato);
      let costumerId = parseInt(third.id_tercero);
      this.setState({ regime: third.id_regimen });

      switch (parseInt(third.tipo)) {
        case 1: //Tercero Normal
          this.setState({ forma_cita: 1 });
          this.loadPlansFromContract(contractId);
          break;
        case 2: //Patrocinador
          this.setState({ forma_cita: 2 });
          this.loadClinicalStudio(costumerId);
          break;

        default:
          this.setState({ forma_cita: 1 });
          this.loadPlansFromContract(contractId);
      }
    }
  };

  handlerPlanFromContractSelected = (plan) => {
    this.setState({ planFromContractSelected: plan });

    this.loadActivities(parseInt(this.state.thirdId), plan).then(
      (activities) => {
        this.setState({ servicesFromPlan: activities });
      }
    );

    this.loadActivitiesPriceList(parseInt(this.state.thirdId), plan);
  };

  handlerActivity = (activity, activityOriginal) => {
    if (
      activity.some(
        (ac) =>
          ac.ind_hospitalizacion &&
          ac.id_servicio == activityOriginal.id_servicio
      )
    ) {
      this.setState({ isModalOpenRoom: true });
    }
    if (
      this.state.confirmedAdditionalAppointments.some(
        (confAdd) =>
          confAdd.detalle_servicio.id_servicio == activityOriginal.id_servicio
      ) != true
    ) {
      if (this.state.activitiesAppointment.length > 0) {
        if (
          this.state.activitiesAppointment.some(
            (ac) => ac.requiere_multicitas == true
          )
        ) {
          if (
            this.state.activitiesAppointment.some(
              (ac) => ac.id_servicio == activityOriginal.id_servicio
            )
          ) {
            this.setState(
              {
                activitiesAppointment: activity.filter(
                  (appointment) =>
                    appointment.id_servicio != activityOriginal.id_servicio
                ),
              },
              () => {
                this.actionsAfterSelectService();
              }
            );
          } else {
            this.setState({
              openAlert: true,
              modalAlert: {
                title: "Servicio Multicitas",
                message:
                  "Ha agregado un servicio de Multicitas, para agendar otro servicio debe hacerlo en citas adicionales",
                color: "danger",
              },
            });
          }
        } else {
          if (activityOriginal.requiere_multicitas != true) {
            this.setState({ activitiesAppointment: activity }, () => {
              this.actionsAfterSelectService();
            });
          } else {
            this.setState({
              openAlert: true,
              modalAlert: {
                title: "Servicio Multicitas",
                message:
                  "No puede agregar un servicio multicitas si ya hay otros servicios asignados, para realizar esta acción debe agendar los servicios elegidos para otro dia en citas adicionales",
                color: "danger",
              },
            });
          }
        }
      } else {
        this.setState({ activitiesAppointment: activity }, () => {
          this.actionsAfterSelectService();
        });
      }
    } else {
      this.setState(
        {
          activitiesAppointment: activity.filter(
            (appointment) =>
              appointment.id_servicio != activityOriginal.id_servicio
          ),
        },
        () => {
          this.actionsAfterSelectService();
        }
      );
    }
  };

  actionsAfterSelectService = () => {
    this.validateControlAppointment();
    this.validateServicesMinDuration();
  };

  validateServicesMinDuration = () => {
    let duration = this.state.activitiesAppointment.reduce((acc, cur) => {
      let defineNullableDuration = cur.duracion ?? 0;
      return acc + defineNullableDuration;
    }, 0);
    this.setState({ servicesSelectedDuration: duration });
  };

  handlerServices = (service) => {
    this.setState({ servicesAppointment: service });
  };

  handlerPlan = (plan) => {
    this.setState({ plan: plan });
    this.setState({ activitiesAppointment: [] });
  };

  handlerObservation = (event) => {
    this.setState({ observation: event.target.value });
  };

  handlerServicios = (event) => {
    this.setState({ servicios: event.target.value });
  };

  handlerLaboratorio = (event) => {
    //this.setState({labs: })
  };

  handlerPossilbledate = (date) => {
    this.setState({ possibleDate: date });
  };

  handleDateAtencion = (date) => {
    this.setState({ fecha_atencion: date });
  };

  handleChange = (event) => {
    let pos;

    let value = this.state.labs;

    if (!value.includes(event.target.value)) {
      value.push(event.target.value);
    } else {
      pos = value.indexOf(event.target.value);
      value.splice(pos, 1);
    }

    this.setState({ labs: value });
  };

  handlerCountry = (country) => {
    this.setState({ country: country });
  };

  handlerDepartment = (department) => {
    this.setState({ department: department, cities: [] }, () => {
      this.loadCities(department).then((cities) => {
        this.setState({ cities: cities });
      });
    });
  };

  handlerCity = (e) => {
    this.setState({ city: e });
  };

  handlerAddress = (address) => {
    this.setState({ address: address });
  };

  handlerZone = (zona) => {
    this.setState({ zone: zona });
  };

  handlerCloseModal = (e) => {
    this.setState({ closeModalRisk: e });
  };

  componentDidMount = () => {
    this.setState(
      {
        id_appointment: this.props.dataEvent.id_cita,
        priority: this.props.dataEvent.priority,
        load: true,
      },
      () => {
        Promise.all([
          this.loadDataProfessional(),
          this.loadThirdPlusContract(),
        ]).then((results) => {
          this.setState(
            { professionals: results[0], serter: results[1] },
            () => {
              if (this.props.hasOwnProperty("dataEvent")) {
                this.setState({
                  professional: this.props.dataEvent.id_profesional,
                  load: false,
                  disableInput: true,
                });
              }
            }
          );
        });
        if (this.props.hasOwnProperty("dataEvent")) {
          this.setState(
            { date: this.props.dataEvent.start, dateEnable: false },
            () => {
              if (
                this.props.dataEvent.id_agenda &&
                this.state.manageStagesAgenda
              ) {
                this.loadJornadasSegmentsByDay(
                  this.props.dataEvent.id_agenda,
                  moment(this.state.date).format("YYYY-MM-DD")
                );
              }
              if (this.props.dataEvent.hasOwnProperty("id_cita")) {
                if (
                  this.props.dataEvent.id_cita !== null &&
                  this.props.dataEvent.id_cita !== ""
                ) {
                  this.loadDataCita();
                }
              }
            }
          );
        }
      }
    );

    this.loadThirdPlusContract();
    this.loadWorkplaces().then(() => {
      if (this.state.workplaces.length === 1) {
        this.setState({ workplaceSelected: this.state.workplaces[0].id_sede });
      }
    });

    this.loadTipoConsulta();

    //Cargue por Defecto
    this.loadCountries().then(() => {
      //Paises
      this.loadDepartment().then((departments) => {
        //Departamentos
        this.setState(
          {
            departments: departments,
            department: parseInt(sessionStorage.getItem("clinica_depcod")),
          },
          () => {
            this.loadCities(this.state.department).then((cities) => {
              this.setState({ cities: cities }, () => {
                this.setState({
                  city: parseInt(sessionStorage.getItem("clinica_ciucod")),
                });
              });
            });
          }
        );
      });
    });

    this.validateShowInfoClinic();
    this.loadPoblacionVulnerable();
  };

  refreshOriginalDates = () => {
    this.setState({
      professional: this.props.dataEvent.id_profesional,
      date: this.props.dataEvent.start,
      serviceChangeDate: null,
    });
  };

  loadPoblacionVulnerable = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "poblacion-vulnerable/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({ poblaciones: data });
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadCountries = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "paises/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ countries: data });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadListaProfesionales = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_PUBLIC_URL +
          `cita/lista-profesionales?document_number=${this.state.document_number}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        }
      );
      const dataProfesional = await response.json();
      this.setState({ listProfesionales: dataProfesional });
      this.setState({ showHistoryMedico: true });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  loadDepartment = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "departamentos/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve(error);
        });
    });
  };

  loadCities = (depcod) => {
    var data = { id_dpto: depcod };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "ciudades/listar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve(error);
        });
    });
  };

  loadDataCita = () => {
    var data = { id_cita: this.props.dataEvent.id_cita };
    //id_agenda: this.props.dataEvent.id_agenda
    fetch(process.env.REACT_APP_PUBLIC_URL + "agenda/consultarpaciente", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.existe) {
          if (data.contenido.pertenece_estudio == false) {
            //Cita medica normal
            Promise.all([
              this.loadPlansFromContract(data.contenido.id_contrato),
              this.loadActivities(
                data.contenido.idCliente,
                data.contenido.idPlan
              ),
              this.loadActivitiesPriceList(
                data.contenido.idCliente,
                data.contenido.idPlan
              ),
              this.loadTipoConsulta(),
            ]).then((results) => {
              this.setState(
                { activities: results[1], tiposConsulta: results[3] },
                () => {
                  let tipoconsulta = null;
                  let serterData = this.state.serter.find(
                    (ser) => ser.id_contrato == data.contenido.id_contrato
                  );
                  let selectedServices = this.filterGetSelectedServices(data);
                  let informacion_femenina = null;

                  if (
                    data.contenido.informacion_femenina != null &&
                    data.contenido.informacion_femenina != undefined
                  ) {
                    informacion_femenina =
                      data.contenido.informacion_femenina.informacion_femenina;
                  }
                  //tipo consulta
                  for (let i = 0; i < results[3].length; i++) {
                    if (
                      results[3][i].id_tipo_consulta ==
                      data?.contenido?.tipo_consulta_info?.id_tipo_consulta
                    ) {
                      tipoconsulta = results[3][i];
                      break;
                    }
                  }

                  this.setState(
                    {
                      costumer_data:
                        serterData != null && serterData != undefined
                          ? serterData
                          : this.state.costumer_data,
                      id_patient: data.contenido.id_paciente,
                      typeOfDocument: data.contenido.tipDoc,
                      name: data.contenido.nombres,
                      document_number: data.contenido.numDoc,
                      last_name: this.validateLastNamePatientFromServer(
                        data.contenido.ape1,
                        data.contenido.ape2
                      ),
                      cellphone: data.contenido.celular,
                      telephone1: data.contenido.telefono1,
                      telephone2: data.contenido.telefono2,
                      email: data.contenido.correo,
                      birthday: new Date(data.contenido.f_nac),
                      history: data.contenido.id_historia,
                      costumer: data.contenido.idCliente,
                      plan: data.contenido.idPlan,
                      //activity: data.contenido.servicios.servicios.id_servicio,
                      load: false,
                      observation: data.contenido.observacion,
                      weight: data.contenido.peso,
                      height: data.contenido.talla,
                      imc: data.contenido.imc,
                      id_history: data.contenido.id_historia,
                      etnia: data.contenido.etnia,
                      poblacionVulnerable:
                        data.contenido.id_poblacion_vulnerable,
                      race: data.contenido.raza,
                      regime: data.contenido.regimen,
                      typeBlood: data.contenido.tipo_sangre,
                      civilStatus: data.contenido.e_civil,
                      gender: data.contenido.sexo,
                      address: data.contenido.direccion.direccion,
                      department: data.contenido.direccion.id_departamento,
                      //city: data.contenido.direccion.ciudad,
                      id_city: data.contenido.direccion.id_ciudad,
                      country: data.contenido.direccion.id_pais,
                      requerimientos_especiales:
                        data.contenido.requerimientos_especiales,
                      caidas: data.contenido.caidas,
                      activitiesAppointment: selectedServices,
                      /* typeConsult: this.validateTypeConsult(
                      data.contenido.tipo_consulta
                    ), */
                      typeConsult: tipoconsulta,
                      menopause:
                        informacion_femenina != null &&
                        informacion_femenina != undefined
                          ? informacion_femenina.menopausia
                          : null,
                      menstruationPatientDate:
                        informacion_femenina != null &&
                        informacion_femenina != undefined
                          ? informacion_femenina.menstruacion
                          : null,
                      planningMethod:
                        informacion_femenina != null &&
                        informacion_femenina != undefined
                          ? informacion_femenina.planificacion
                          : null,
                      pregnancyTest:
                        informacion_femenina != null &&
                        informacion_femenina != undefined
                          ? informacion_femenina.embarazo
                          : null,
                      firstAppointment:
                        data.contenido.primera_vez != null &&
                        data.contenido.primera_vez != undefined
                          ? data.contenido.primera_vez
                          : "No",
                      typeDate:
                        data.contenido.tipo_cita_agenda != null &&
                        data.contenido.tipo_cita_agenda != undefined
                          ? data.contenido.tipo_cita_agenda
                          : "Normal",
                      possibleDate:
                        data.contenido.fecha_deseada != null &&
                        data.contenido.fecha_deseada != undefined
                          ? data.contenido.fecha_deseada
                          : null,
                      ageLetters: calculateAgeParse(
                        new Date(data.contenido.f_nac)
                      ),
                      appointmentExist: true,
                      userAppoint: data.contenido.nombre_usuario,
                      appointsmentsDate: data.contenido.fecha_agendada_cita,
                      workplaceSelected: data.contenido.id_sede,
                    },
                    () => {
                      this.loadDepartment().then((deps) => {
                        this.setState({ departments: deps }, () => {
                          this.loadCities(
                            data.contenido.direccion.id_departamento
                          ).then((cities) => {
                            this.setState({
                              cities: cities,
                              city: data.contenido.direccion.id_ciudad,
                            });
                          });
                        });
                      });
                    }
                  );
                  //this.loadDataCostumer(data.contenido.idCliente);
                }
              );
            });
          } else {
            //Cita Medica de Estudio Clinico
            this.setState({ forma_cita: 2 });
            Promise.all([
              this.loadClinicalStudio(data.contenido.idCliente),
              this.loadVisitas(
                data.contenido.estudio_detalle.detalle.estudio_clinico
                  .id_factibilidad
              ),
            ]).then((results) => {
              this.setState(
                { estudios_clinicos: results[0], visitas: results[1] },
                () => {
                  let estudio = null;
                  let visita = null;
                  //Estudio Clinico
                  for (let i = 0; i < results[0].length; i++) {
                    if (
                      results[0][i].id_estudio ==
                      data.contenido.estudio_detalle.detalle.estudio_clinico
                        .id_estudio
                    ) {
                      estudio = results[0][i];
                      break;
                    }
                  }
                  //Visita
                  for (let i = 0; i < results[1].length; i++) {
                    if (
                      results[1][i].id_visita ==
                      data.contenido.estudio_detalle.detalle.visita.id_visita
                    ) {
                      visita = results[1][i];
                      break;
                    }
                  }

                  this.setState(
                    {
                      id_patient: data.contenido.id_paciente,
                      name: data.contenido.nombres,
                      document_number: data.contenido.numDoc,
                      typeOfDocument: data.contenido.tipDoc,
                      last_name: this.validateLastNamePatientFromServer(
                        data.contenido.ape1,
                        data.contenido.ape2
                      ),
                      cellphone: data.contenido.celular,
                      telephone1: data.contenido.telefono1,
                      telephone2: data.contenido.telefono2,
                      email: data.contenido.correo,
                      birthday: new Date(data.contenido.f_nac),
                      history: data.contenido.id_historia,
                      costumer: data.contenido.idCliente,
                      estudio_clinico: estudio,
                      visita: visita,
                      load: false,
                      weight: data.contenido.peso,
                      height: data.contenido.talla,
                      imc: data.contenido.imc,
                      id_history: data.contenido.id_historia,
                      etnia: data.contenido.etnia,
                      race: data.contenido.raza,
                      regime: data.contenido.regimen,
                      typeBlood: data.contenido.tipo_sangre,
                      civilStatus: data.contenido.e_civil,
                      gender: data.contenido.sexo,
                      address: data.contenido.direccion.direccion,
                      department: data.contenido.direccion.id_departamento,
                      city: data.contenido.direccion.ciudad,
                      id_city: data.contenido.direccion.id_ciudad,
                      country: data.contenido.direccion.id_pais,
                      requerimientos_especiales:
                        data.contenido.requerimientos_especiales,
                      caidas: data.contenido.caidas,
                      appointmentExist: true,
                      userAppoint: data.contenido.nombre_usuario,
                    },
                    () => {
                      this.loadDepartment();
                      this.loadCities(this.state.department);
                    }
                  );
                  this.loadDataCostumer(data.contenido.idCliente);
                }
              );
            });
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  filterGetSelectedServices = (data) => {
    let selectedServices = [];
    for (let i = 0; i < data.contenido.servicios.servicios.length; i++) {
      let serData = this.state.activities.find(
        (dat) =>
          parseInt(dat.id_servicio) ==
          parseInt(data.contenido.servicios.servicios[i].id_servicio)
      );
      if (serData != null && serData != undefined) {
        selectedServices.push(serData);
      }
    }
    return selectedServices;
  };

  loadDataCostumer = (id_cliente) => {
    for (let i = 0; i < this.state.serter.length; i++) {
      if (this.state.serter[i].id_tercero == id_cliente) {
        this.setState({
          costumer_data: this.state.serter[i],
          costumer_name: this.state.serter[i].nombre,
        });
        break;
      }
    }
  };

  loadIdentity = async () => {
    var body = { num_documento: this.state.document_number };

    try {
      const response = await fetch(
        process.env.REACT_APP_PUBLIC_URL + "paciente/consultar",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(body),
        }
      );

      const data = await response.json();

      if (data.existe) {
        let informacion_femenina = null;
        if (
          data.contenido[0].informacion_femenina != null &&
          data.contenido[0].informacion_femenina != undefined
        ) {
          informacion_femenina =
            data.contenido[0].informacion_femenina.informacion_femenina;
        }
        this.setState({
          typeOfDocument: this.state.typeOfDocument,
          id_patient: data.contenido[0].id_paciente,
          name: data.contenido[0].nombres,
          last_name: this.validateLastNamePatientFromServer(
            data.contenido[0].apellido1,
            data.contenido[0].apellido2
          ),
          telephone1: data.contenido[0].telefono1,
          telephone2: data.contenido[0].telefono2,
          email: data.contenido[0].correo,
          cellphone: data.contenido[0].celular,
          gender: data.contenido[0].sexo,
          birthday: data.contenido[0].fec_nacimiento,
          history: data.contenido[0].id_historia,
          country: data.contenido[0].direccion.id_pais,
          address: data.contenido[0].direccion.direccion,
          patienteExist: data.existe,
          zone: data.contenido[0].zona,
          disableInput: true,
          id_history: data.contenido[0].id_historia,
          etnia: data.contenido[0].id_etnia,
          race: data.contenido[0].id_raza,
          regime: data.contenido[0].id_regimen,
          typeBlood: data.contenido[0].tipo_sangre,
          civilStatus: data.contenido[0].e_civil,
          menopause:
            informacion_femenina != null && informacion_femenina != undefined
              ? informacion_femenina.menopausia
              : null,
          menstruationPatientDate:
            informacion_femenina != null && informacion_femenina != undefined
              ? informacion_femenina.menstruacion
              : null,
          planningMethod:
            informacion_femenina != null && informacion_femenina != undefined
              ? informacion_femenina.planificacion
              : null,
          pregnancyTest:
            informacion_femenina != null && informacion_femenina != undefined
              ? informacion_femenina.embarazo
              : null,
          ageLetters: calculateAgeParse(data.contenido[0].fec_nacimiento),
          poblacionVulnerable: data.contenido[0].id_poblacion_vulnerable,
        });

        //Si pertenece a un estudio clinico cargue las visitas
        if (
          this.state.estudio_clinico != undefined &&
          this.state.estudio_clinico != null
        ) {
          this.loadVisitasPatient(
            this.state.estudio_clinico.id_factibilidad,
            data.contenido[0].id_paciente
          );
        } else {
          this.setState({ visita: null });
          this.setState({ visitas: [] });
        }

        const departments = await this.loadDepartment();
        //Departamentos
        this.setState(
          {
            departments: departments,
            department: data.contenido[0].direccion.id_departamento,
          },
          async () => {
            const cities = await this.loadCities(this.state.department);
            this.setState({ cities: cities }, () => {
              this.setState({
                city: data.contenido[0].direccion.id_ciudad,
                id_city: data.contenido[0].direccion.id_ciudad,
              });
            });
          }
        );
      } else {
        this.setState(
          {
            id_patient: null,
            name: "",
            last_name: "",
            cellphone: "",
            telephone1: "",
            telephone2: "",
            email: "",
            gender: "",
            address: "",
            zone: "U",
            birthday: null,
            history: null,
            visita: null,
            visitas: [],
            //typeOfDocument: "",
            patienteExist: data.existe,
            disableInput: false,
            ageLetters: "",
            poblacionVulnerable: "",
          },
          () => {
            this.setState(
              {
                department: parseInt(sessionStorage.getItem("clinica_depcod")),
              },
              () => {
                this.loadCities(this.state.department).then((cities) => {
                  this.setState({ cities: cities }, () => {
                    this.setState({
                      city: parseInt(sessionStorage.getItem("clinica_ciucod")),
                    });
                  });
                });
              }
            );
          }
        );
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  loadDataProfessional = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "profesional/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadClientAndActivity = () => {
    return new Promise((resolve, reject) => {
      //let url = "serter/listar_con_plan";
      let url = "tercero/listar-terceros-indicadores";

      fetch(process.env.REACT_APP_PUBLIC_URL + url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadPlans = (tercero) => {
    return new Promise((resolve, reject) => {
      var data = { id: tercero };
      fetch(process.env.REACT_APP_PUBLIC_URL + "plan/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.existe) {
            //this.setState({plans: data.contenido, activities: [], activity: null });
            resolve(data.contenido);
          } else {
            resolve([]);
            //this.setState({plans:[], plan: null, activities: [], activity: null});
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadActivities = (tercero, plan) => {
    return new Promise((resolve, reject) => {
      let nuevaCita = true;
      if (this.props.hasOwnProperty("dataEvent")) {
        if (this.props.dataEvent.hasOwnProperty("id_cita")) {
          if (
            this.props.dataEvent.id_cita != null &&
            this.props.dataEvent.id_cita != undefined &&
            this.props.dataEvent.id_cita != ""
          ) {
            nuevaCita = false;
          }
        }
      }
      let url = `serter/verificar-profesional?id_tercero=${tercero}&id_plan=${plan}&id_profesional=${this.props.dataEvent.id_profesional}&cita_nueva=${nuevaCita}`;
      fetch(process.env.REACT_APP_PUBLIC_URL + url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadActivitiesPriceList = (tercero, plan) => {
    return new Promise((resolve, reject) => {
      var data = { id_tercero: tercero, id_plan: plan };
      fetch(process.env.REACT_APP_PUBLIC_URL + "serter/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.existe) {
            this.setState(
              { activitiesPriceList: data.contenido[0].servicios.servicios },
              () => {
                if (this.state.activitiesPriceList.length < 0) {
                  this.setState({
                    activities: data.contenido[0].servicios.servicios,
                  });
                }
              }
            );
            resolve(data.contenido[0].servicios.servicios);
          } else {
            resolve([]);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadService = (id) => {
    let data = { id_servicio: id };

    fetch(process.env.REACT_APP_PUBLIC_URL + "servicio/consultar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          servicios: data.contenido[0],
          labs: data.contenido[0].servicio.servicios,
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  //Carga el nombre del tercero mas los contratos de ese tercero y su regimen
  loadThirdPlusContract = async () => {
    let nuevaCita = true;
    if (this.props.hasOwnProperty("dataEvent")) {
      if (this.props.dataEvent.hasOwnProperty("id_cita")) {
        if (
          this.props.dataEvent.id_cita != null &&
          this.props.dataEvent.id_cita != undefined &&
          this.props.dataEvent.id_cita != ""
        ) {
          nuevaCita = false;
        }
      }
    }

    let datos = [];
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "agenda/listar-terceros?nueva_cita=" +
        nuevaCita,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        datos = data;
        //this.setState({ thirdPlusContract: data });
        return datos;
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    return datos;
  };
  //Carga los planes del contrato seleccionado
  loadPlansFromContract = async (id) => {
    let data = { id_contrato: id };

    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "plan/consultar_x_contrato",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.existe) {
          this.setState({ plans: data.contenido });
        } else {
          this.setState({ plans: [] });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  alertModal = (title, message, color) => {
    this.setState({
      openAlert: true,
      modalAlert: { title: title, message: message, color: color },
    });
  };

  reglasDocumento = {
    CC: {
      regex: /^\d{3,10}$/,
      mensaje: "Debe tener máximo 10 dígitos númericos y sin espacios",
    },
    CE: {
      regex: /^[a-zA-Z0-9]{3,7}$/,
      mensaje: "Debe tener máximo 7 dígitos y sin espacios",
    },
    CD: {
      regex: /^[a-zA-Z0-9]{3,11}$/,
      mensaje: "Debe tener máximo 11 dígitos y sin espacios",
    },
    PA: {
      regex: /^[a-zA-Z0-9]{3,16}$/,
      mensaje: "Debe tener máximo 16 dígitos y sin espacios",
    },
    SC: {
      regex: /^\d{1,8}$/,
      mensaje: "Debe tener máximo 8 dígitos y sin espacios",
    },
    PE: {
      regex: /^\d{1,15}$/,
      mensaje: "Debe tener máximo 15 dígitos y sin espacios",
    },
    RC: {
      regex: /^(?:\d{1,11}|[a-zA-Z0-9]{1,10})$/,
      mensaje: "Debe tener máximo 11 dígitos númericos y sin espacios",
    },
    TI: {
      regex: /^(?:\d{1,11}|[a-zA-Z0-9]{1,10})$/,
      mensaje: "Debe tener máximo 10 dígitos y sin espacios",
    },
    CN: {
      regex: /^\d{1,9}$|^\d{14}$/,
      mensaje: "Debe tener máximo 9 o 14 dígitos númericos",
    },
    AS: {
      regex: /^[a-zA-Z0-9]{1,10}$/,
      mensaje: "Debe tener máximo 10 dígitos y sin espacios",
    },
    MS: {
      regex: /^[a-zA-Z0-9]{1,10}$/,
      mensaje: "Debe tener máximo 10 dígitos y sin espacios",
    },
    DE: {
      regex: /^[a-zA-Z0-9]{1,20}$/,
      mensaje: "Debe tener máximo 20 dígitos y sin espacios",
    },
    PT: {
      regex: /^\d{1,8}$/,
      mensaje: "Debe tener máximo 8 dígitos y sin espacios",
    },
    SI: {
      regex: /^[a-zA-Z0-9]{1,20}$/,
      mensaje: "Debe tener máximo 20 dígitos y sin espacios",
    },
  };

  validationDocLength = (numDocumento) => {
    var errors = this.state.errors;
    var error = false;

    const regla = this.reglasDocumento[this.state.typeOfDocument];
    if (regla && !regla.regex.test(numDocumento)) {
      errors.document_number = regla.mensaje;
      error = true;
    } else {
      errors.document_number = "";
    }

    this.setState({ errors: errors, error: error });
    return error;
  };

  validate = () => {
    var errors = this.state.errors;
    var error = false;

    if (this.state.typeOfDocument === "") {
      errors.typeOfDocument = "Seleccione un tipo de documento";
      error = true;
    } else {
      errors.typeOfDocument = "";
    }

    if (
      this.state.poblacionVulnerable === "" ||
      this.state.poblacionVulnerable === null
    ) {
      errors.poblacionVulnerable = "Seleccione una población vulnerable";
      error = true;
    } else {
      errors.poblacionVulnerable = "";
    }

    if (
      this.state.workplaceSelected === "" ||
      this.state.workplaceSelected === null
    ) {
      errors.workplaceSelected = "Seleccione una sede";
      error = true;
    } else {
      errors.workplaceSelected = "";
    }

    if (this.state.professional === null) {
      errors.professional = "Seleccione un Profesional";
      error = true;
    } else {
      errors.professional = "";
    }

    if (this.state.document_number === "") {
      errors.document_number = "Ingrese un número de documento";
      error = true;
    } else {
      errors.document_number = "";
    }

    if (this.state.name.trim(" ") === "") {
      errors.name = "Ingrese un nombre";
      error = true;
    } else if (!this.state.name.match(/^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ ]+$/)) {
      errors.name = "Debe tener sólo letras";
      error = true;
    } else {
      errors.name = "";
    }

    if (this.state.last_name.trim(" ") === "") {
      errors.last_name = "Ingrese apellidos";
      error = true;
    } else if (!this.state.last_name.match(/^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ ]+$/)) {
      errors.last_name = "Debe tener sólo letras";
      error = true;
    } else {
      errors.last_name = "";
    }

    if (!this.state.email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) {
      errors.email = "Ingrese un e-mail válido";
      error = true;
    } else {
      errors.email = "";
    }

    if (this.state.birthday === null || this.state.birthday === "") {
      errors.birthday = "Seleccione una fecha de nacimiento";
      error = true;
    } else {
      if (
        moment(this.state.birthday).format("YYYY/MM/DD").toString() ===
        moment(new Date()).add(1).format("YYYY/MM/DD").toString()
      ) {
        errors.birthday = "Seleccione una fecha de nacimiento";
        error = true;
      } else {
        errors.birthday = "";
      }
    }

    if (this.state.costumer === null) {
      errors.costumer = "Seleccione una IPS";
      error = true;
    } else {
      errors.costumer = "";
    }

    //Esteban Londoño Ospina 24/09/2021
    //Validacion de Cita
    if (this.state.forma_cita != 1) {
      if (this.state.estudio_clinico === null) {
        errors.estudio_clinico = "Seleccione un estudio clinico";
        error = true;
      } else {
        errors.estudio_clinico = "";
      }

      if (this.state.visita === null) {
        errors.visita = "Seleccione una visita";
        error = true;
      } else {
        errors.visita = "";
      }
    } else {
      if (this.state.plan === null) {
        errors.plan = "Seleccione un plan";
        error = true;
      } else {
        errors.plan = "";
      }

      if (this.state.activitiesAppointment.length <= 0) {
        errors.activitiesAppointment =
          "Seleccione al menos una actividad y/o servicio";
        error = true;
      } else {
        errors.activitiesAppointment = "";
      }
    }

    if (this.state.telephone1 === "" || this.state.telephone1 === null) {
      errors.telephone1 = "Escriba al menos un Telefono";
      error = true;
    } else if (!this.state.telephone1.match(/^[0-9]+$/)) {
      errors.telephone1 = "Debe tener sólo números y sin espacios";
      error = true;
    } else {
      errors.telephone1 = "";
    }

    if (this.state.cellphone === "") {
      errors.cellphone = "Escriba un celular";
      error = true;
    } else if (!this.state.cellphone.match(/^[0-9]+$/)) {
      errors.cellphone = "Debe tener sólo números y sin espacios";
      error = true;
    } else {
      errors.cellphone = "";
    }

    if (this.state.gender === "") {
      errors.gender = "Selecione un genero";
      error = true;
    } else {
      errors.gender = "";
    }

    if (this.state.country === "") {
      errors.country = "Seleccione un país";
      error = true;
    } else {
      errors.country = "";
    }

    if (this.state.department === "") {
      errors.department = "Seleccione un departamento";
      error = true;
    } else {
      errors.department = "";
    }

    if (this.state.city === "") {
      errors.city = "Seleccione una ciudad";
      error = true;
    } else {
      errors.department = "";
    }

    if (this.state.typeDate === "") {
      errors.typeDate = "Seleccione un tipo de dato";
      error = true;
    } else {
      errors.typeDate = "";
    }

    if (this.state.possibleDate === null) {
      errors.possibleDate = "Seleccione una fecha deseada de cita";
      error = true;
    } else {
      errors.possibleDate = "";
    }

    if (this.state.address === "") {
      errors.address = "Ingrese una dirección";
      error = true;
    } else if (!this.state.address.match(/^[a-zA-Z0-9\s]+$/)) {
      errors.address = "Ingrese una dirección sin caracteres especiales";
      error = true;
    } else {
      errors.address = "";
    }

    if (this.state.listTipos.includes("3")) {
      if (this.state.weight === "") {
        errors.weight = "Ingrese el peso";
        error = true;
      } else {
        errors.weight = "";
      }

      if (this.state.height === "") {
        errors.height = "Ingrese la talla";
        error = true;
      } else if (this.state.height < 20) {
        errors.height = "Ingrese una talla mayor a 20cm";
        error = true;
      } else {
        errors.height = "";
      }
    }

    if (
      this.state.typeConsult === null ||
      this.state.typeConsult === "" ||
      this.state.typeConsult === undefined
    ) {
      errors.typeConsult = "Seleccione un tipo de consulta";
      error = true;
    } else {
      errors.typeConsult = "";
    }

    if (
      !!!this.state.tiposConsulta.find(
        (tipo) =>
          tipo.id_tipo_consulta == this.state.typeConsult.id_tipo_consulta &&
          tipo.estado === "A"
      )
    ) {
      errors.typeConsult = "Seleccione un tipo de consulta";
      error = true;
    } else {
      errors.typeConsult = "";
    }

    if (error == false) {
      let validateQueryProcedure = this.validatedQuerysAndProcedures();
      if (!validateQueryProcedure) {
        this.setState({
          openAlert: true,
          modalAlert: {
            title: "Consultas y Procedimientos mezclados",
            message:
              "No puede asignar una cita con una consulta y un procedimiento al mismo tiempo",
            color: "danger",
          },
        });
        error = true;
      }
    }

    if (this.state.listTipos.includes("3") || this.state.showFallingRisks) {
      if (
        this.state.caidas == null ||
        JSON.stringify(this.state.caidas) === "{}" ||
        this.state.caidas == undefined
      ) {
        this.setState({
          openAlert: true,
          modalAlert: {
            title: "El riesgo de caída no se ha diligenciado",
            message: "Para continuar con el agendamiento debe de llenarlo",
            color: "warning",
          },
        });
        error = true;
      }
    }

    if (this.state.listTipos.includes("3") || this.state.showSpecialReq) {
      if (
        this.state.requerimientos_especiales == null ||
        JSON.stringify(this.state.requerimientos_especiales) === "{}" ||
        this.state.requerimientos_especiales == undefined
      ) {
        this.setState({
          openAlert: true,
          modalAlert: {
            title: "Los requerimientos Especiales no se han diligenciado",
            message: "Para continuar con el agendamiento debe de llenarlo",
            color: "warning",
          },
        });
        error = true;
      }
    }

    this.setState({ errors: errors, error: error });
    return error;
  };

  sendRoomAppointment = (cita) => {
    if (this.state.room === "") {
      return;
    }
    var data = {
      id_cita: cita.id_cita,
      id_habitacion: this.state.room,
      fecha_asignacion: cita.inicio,
      cancelada: cita.cancelada,
    };

    fetch(process.env.REACT_APP_PUBLIC_URL + "cita-habitacion/create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Error");
        }
      })
      .then((data) => {
        this.setState({
          openAlert: true,
          modalAlert: {
            title: "Exitoso",
            message: "Cita de la habitacion Asignada Correctamente",
            color: "success",
          },
        });
      })
      .catch((error) => {
        this.setState({
          openAlert: true,
          modalAlert: {
            title: "Error",
            message:
              "Ha ocurrido un error registrando la habitacion de la cita",
            color: "danger",
          },
        });
        console.error("Error:", error);
      });
  };

  sendAsign = () => {
    if (this.state.patienteExist) {
      if (!this.validate()) {
        this.setState({ loadingProcess: true }, () => {
          let organizedIdsSelectedStages = this.state.idStagesAgenda
            .map((num) => num)
            .sort((a, b) => a - b);
          //Esteban Londoño Ospina 24/09/2021
          //Si pertenece a un estudio Clinico guardelo, de lo contrario guarde las actividades

          let titulo = null;
          let estudio_detalle = null;
          if (this.state.forma_cita == 1) {
            titulo = this.state.activitiesAppointment[0].servicios;
          } else {
            titulo =
              this.state.estudio_clinico.acronimo +
              "-" +
              this.state.visita.nombre;
            estudio_detalle = {
              estudio_clinico: this.state.estudio_clinico,
              visita: this.state.visita,
            };
          }

          let informacion_femenina = null;
          if (
            this.state.gender.toUpperCase() == "FEMENINO" &&
            this.state.showFeminineInfo
          ) {
            informacion_femenina = {
              menopausia: this.state.menopause,
              menstruacion: this.state.menstruationPatientDate,
              planificacion: this.state.planningMethod,
              embarazo: this.state.pregnancyTest,
            };
          }

          var data = {
            title: titulo,
            id: this.props.dataEvent.id,
            id_espacio: this.props.dataEvent.espacio,
            id_agenda: this.props.dataEvent.id_agenda, //this.props.dataEvent.id_agenda != undefined? this.props.dataEvent.id_agenda: this.state.professionals.filter((professional)=> { return professional.id_profesional == this.state.professional})[0].id_agenda_activa,
            id_historia: this.state.history,
            id_tercero: this.state.costumer,
            id_plan: this.state.plan,
            servicio: this.state.activitiesAppointment,
            fecha_deseada: this.state.possibleDate,
            fecha_solicitud: this.state.solicitDate,
            estudio_detalle: estudio_detalle,
            observacion: this.state.observation,
            peso: this.state.weight,
            talla: this.state.height,
            imc: this.state.imc,
            tipo_consulta: this.state.typeConsult.id_tipo_consulta,
            requerimientos_especiales: this.state.requerimientos_especiales,
            caidas: this.state.caidas,
            id_usuario:
              this.state.user != null && this.state.user != undefined
                ? this.state.user.id_usuario
                : JSON.parse(sessionStorage.getItem("usuario")).id_usuario,
            citas_adicionales: this.state.confirmedAdditionalAppointments,
            informacion_femenina: informacion_femenina,
            nombre_fase: this.state.nameInitialPhase,
            primera_vez: this.state.firstAppointment,
            tipo_cita_agenda: this.state.typeDate,
            fecha_agendada_cita: new Date(),
            isTheServicePaid: this.state.verifyPaymentServiceControl,
            idSede: this.state.workplaceSelected,
            idsJornadas: organizedIdsSelectedStages,
            id_regimen: this.state.regime,
            id_habitacion: this.state.room,
            id_poblacion_vulnerable: this.state.poblacionVulnerable,
          };

          fetch(process.env.REACT_APP_PUBLIC_URL + "cita/create", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: "Bearer " + sessionStorage.getItem("token"),
            },
            body: JSON.stringify(data),
          })
            .then((response) => {
              if (response.status != 500 && response.status != 403) {
                return response.json();
              } else {
                throw new Error(response.text());
              }
            })
            .then((data) => {
              this.sendRoomAppointment(data.cita);
              try {
                this.sendMessages();
              } catch (e) {
                console.error(e);
              }
              this.setState({
                openAlert: true,
                modalAlert: {
                  title: "Exitoso",
                  message: "Cita Asignada Correctamente",
                  color: "success",
                },
                priority: "Reservada",
                id_appointment: 1,
                loadingProcess: false,
              });
            })
            .catch((error) => {
              this.setState({
                openAlert: true,
                modalAlert: {
                  title: "Error",
                  message:
                    "Ha ocurrido un error registrando la Cita, es posible que esta Jornada ya este ocupada por otro paciente",
                  color: "danger",
                },
                loadingProcess: false,
              });
              console.error("Error:", error);
            });
        });
      }
    } else {
      if (!this.validate()) {
        this.createPatient();
      }
    }
  };

  sendMessages = async () => {
    try {
      let firtsLastNamePatient = splitNames(this.state.last_name);
      let lastNamePatient = !!firtsLastNamePatient
        ? !!firtsLastNamePatient.length
          ? firtsLastNamePatient[0]
          : ""
        : "";
      let patientSend = new PatientSends();
      let srOSra = "";
      if (this.state.gender.toUpperCase() == "MASCULINO") {
        srOSra = "Sr";
      } else {
        srOSra = "Sr(a)";
      }

      //Armado del Mensaje
      patientSend.message =
        "Sr(a) " +
        this.state.name +
        " " +
        lastNamePatient +
        " se le ha asignado una cita medica para la fecha ";
      patientSend.message =
        patientSend.message +
        moment(this.state.date).format("DD/MM/YYYY h:mm:ss a").toString();
      patientSend.phone = this.state.cellphone.toString();

      //Doctor o Doctora
      let doctor = this.state.professionals.find(
        (professional) =>
          professional.id_profesional === this.state.professional
      );
      let abreviaturaDoctor =
        " con el Dr " + doctor.nombres + " " + doctor.apellido1;
      if (doctor.sexo != null && doctor.sexo != undefined) {
        if (doctor.sexo.toUpperCase() == "FEMENINO") {
          abreviaturaDoctor =
            " con la Dra " + doctor.nombres + " " + doctor.apellido1;
        }
      }
      patientSend.message = patientSend.message + abreviaturaDoctor;

      await patientSend.sendSMS();

      //Si el Paciente tiene correo electronico se le puede enviar un correo electronico
      if (
        this.state.email != "NOTIENE@CORREO.COM" &&
        this.state.email != "" &&
        this.state.email != null &&
        this.state.email !== undefined
      ) {
        patientSend.matter = "Cita Asignada";
        patientSend.email = this.state.email;
        patientSend.listServicesString = this.state.activitiesAppointment;
        await patientSend.sendEmail();
      }
    } catch (e) {
      console.error(e);
    }
  };

  updatePatient = async () => {
    try {
      const lastNames = splitNames(this.state.last_name);
      const body = {
        ape1: lastNames[0],
        ape2: lastNames[1],
        nombres: this.state.name,
        sexo: this.state.gender,
        fec_nacimiento: moment(this.state.birthday).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        direccion: {
          id_pais: this.state.country,
          departamento: this.state.departments.filter(
            (department) =>
              department.depcod.toString() === this.state.department.toString()
          )[0].depnom,
          id_departamento: this.state.department,
          ciudad: this.state.cities.filter(
            (city) => city.ciucod.toString() === this.state.city.toString()
          )[0].ciunom,
          id_ciudad: this.state.city,
          direccion: this.state.address,
        },
        telefono1: this.state.telephone1,
        telefono2: this.state.telephone2,
        celular: this.state.cellphone,
        correo: this.state.email,
        e_civil: this.state.civilStatus,
        id_etnia: this.state.etnia,
        id_raza: this.state.race,
        id_regimen: this.state.regime,
        tipo_sangre: this.state.typeBlood,
        //fec_ingreso: this.state.fec_ingreso,
        id_paciente: this.state.id_patient,
        id_historia: this.state.id_history,
        zona: this.state.zone,
        num_documento: this.state.document_number,
        tipo_documento: this.state.typeOfDocument,
        id_poblacion_vulnerable: this.state.poblacionVulnerable,
      };

      const response = await fetch(
        process.env.REACT_APP_PUBLIC_URL + "paciente/update",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(body),
        }
      );

      if (response.status === 200) {
        const data = await response.json();
        this.setState({
          openAlert: true,
          modalAlert: {
            message: "Paciente actualizado con exito",
            color: "success",
            title: "Exitoso!",
          },
        });
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  cancelAppointment = () => {
    var data = {
      id_cita_agendada: this.props.dataEvent.id,
      id_agenda:
        this.props.dataEvent.id_agenda !== undefined
          ? this.props.dataEvent.id_agenda
          : this.state.professionals.filter((professional) => {
              return professional.id_profesional === this.state.professional;
            })[0].id_agenda_activa,
      obcancelacion: this.state.cancelObservation,
      tipo_cancelacion: this.state.cancelType,
    };

    fetch(process.env.REACT_APP_PUBLIC_URL + "agenda/cancelarcita", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.cancelada) {
          this.setState({
            openAlert: true,
            modalAlert: {
              title: "Exitoso",
              message: data.contenido,
              color: "success",
            },
            id_appointment: "",
            priority: "Disponible",
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  missAppointment = () => {
    var data = {
      id_cita_agendada: this.props.dataEvent.id,
      id_agenda:
        this.props.dataEvent.id_agenda !== undefined
          ? this.props.dataEvent.id_agenda
          : this.state.professionals.filter((professional) => {
              return professional.id_profesional === this.state.professional;
            })[0].id_agenda_activa,
    };

    fetch(process.env.REACT_APP_PUBLIC_URL + "agenda/citaincumplida", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.incumplida) {
          this.setState({
            openAlert: true,
            modalAlert: {
              title: "Exitoso",
              message: data.contenido,
              color: "success",
            },
            priority: "Incumplida",
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  disableAppointment = () => {
    var data = {
      id_cita_agendada: this.props.dataEvent.id,
      id_agenda:
        this.props.dataEvent.id_agenda !== undefined
          ? this.props.dataEvent.id_agenda
          : this.state.professionals.filter((professional) => {
              return professional.id_profesional === this.state.professional;
            })[0].id_agenda_activa,
    };
    fetch(process.env.REACT_APP_PUBLIC_URL + "agenda/inactivarcita", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.inactivada) {
          this.setState({
            openAlert: true,
            modalAlert: {
              title: "Exitoso",
              message: data.contenido,
              color: "success",
            },
            priority: "Inactiva",
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  enableAppointment = () => {
    var data = {
      id_cita_agendada: this.props.dataEvent.id,
      id_agenda:
        this.props.dataEvent.id_agenda !== undefined
          ? this.props.dataEvent.id_agenda
          : this.state.professionals.filter((professional) => {
              return professional.id_profesional === this.state.professional;
            })[0].id_agenda_activa,
    };
    fetch(process.env.REACT_APP_PUBLIC_URL + "agenda/activarcita", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.activada) {
          this.setState({
            openAlert: true,
            modalAlert: {
              title: "Exitoso",
              message: data.contenido,
              color: "success",
            },
            priority: "Disponible",
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  sendDataAdmission = () => {
    history.push({
      pathname: process.env.PUBLIC_URL + "/assitencial/add-admission",
      state: {
        id_cita: this.props.dataEvent.id_cita,
        id_historia: this.props.dataEvent.id_historia,
        document_number: this.state.document_number,
        type_document: this.state.type_document,
        workspace: this.props.dataEvent.espacio,
        e_civil: this.props.dataEvent.e_civil,
        id_agenda: this.props.dataEvent.id_agenda,
        id_bloque: this.props.dataEvent.bloque,
        priority: this.props.dataEvent.priority,
        cita: {
          id_cliente: this.state.costumer,
          id_plan: this.state.plan,
          id_profesional: this.state.professional,
          fecha: this.state.date,
        },
        requerimientos_especiales:
          this.state.requerimientos_especiales != undefined &&
          this.state.requerimientos_especiales != null
            ? this.state.requerimientos_especiales
            : null,
        caidas:
          this.state.caidas != undefined && this.state.caidas != null
            ? this.state.caidas
            : null,
        id_poblacion_vulnerable: this.state.poblacionVulnerable,
      },
    });
  };

  handlerDocumentNumber = async (event) => {
    let noSpaces = event.target.value.trim();
    await this.setState({ document_number: noSpaces }, async () => {
      this.cleanDataPregantInformation();
      if (!this.state.updateData) {
        await this.loadIdentity();
        await this.loadListaProfesionales();
      }
    });
  };

  handleTypeDocument = (event) => {
    this.setState({ typeOfDocument: event.target.value });
  };

  handlerName = (event) => {
    this.setState({ name: event.target.value.toUpperCase() });
  };

  handlerLastName = (event) => {
    this.setState({ last_name: event.target.value.toUpperCase() });
  };

  handlerCellphone = (event) => {
    this.setState({ cellphone: event.target.value });
  };

  handlerTelephone1 = (event) => {
    this.setState({ telephone1: event.target.value });
  };

  handlerTelephone2 = (event) => {
    this.setState({ telephone2: event.target.value });
  };

  handlerEmail = (event) => {
    this.setState({ email: event.target.value.toUpperCase() });
  };

  //#region Estudios Clinicos
  loadClinicalStudio = async (id_tercero) => {
    return new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_PUBLIC_URL + "estudiosc/consultar-por-tercero",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify({ id_tercero: id_tercero }),
        }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({ estudios_clinicos: data });
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve([]);
        });
    });
  };

  handlerChangeClinicalStudio = async (value) => {
    this.setState({ estudio_clinico: value });

    if (value != null) {
      this.loadVisitasPatient(value.id_factibilidad, this.state.id_patient);
    } else {
      this.setState({ visita: null });
      this.setState({ visitas: [] });
    }
  };

  loadVisitasPatient = (id_factibilidad, id_paciente) => {
    return new Promise((resolve, reject) => {
      let url = "visitas/verificar-paciente";
      url += "?id_factibilidad=" + id_factibilidad;

      if (id_paciente != null && id_paciente != undefined) {
        url += "&id_paciente=" + id_paciente;
      }

      fetch(process.env.REACT_APP_PUBLIC_URL + url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({ visitas: data.contenido });
          resolve(data.contenido);
        })
        .catch((error) => {
          console.error("Error:", error);
          this.setState({ visitas: [] });
          resolve([]);
        });
    });
  };

  //Muestra todas las visitas, solo disponible para citas YA EXISTENTES
  loadVisitas = (id_factibilidad) => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "visitas/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify({ id_factibilidad: id_factibilidad }),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({ visitas: data.contenido });
          resolve(data.contenido);
        })
        .catch((error) => {
          console.error("Error:", error);
          this.setState({ visitas: [] });
          resolve([]);
        });
    });
  };

  createPatient = () => {
    this.setState({ loadingProcess: true }, () => {
      let organizedIdsSelectedStages = this.state.idStagesAgenda
        .map((num) => num)
        .sort((a, b) => a - b);
      var lastNames = splitNames(this.state.last_name);
      let titulo = null;
      let estudio_detalle = null;
      if (this.state.forma_cita == 1) {
        titulo = this.state.activitiesAppointment[0].servicios;
      } else {
        titulo =
          this.state.estudio_clinico.acronimo + "-" + this.state.visita.nombre;
        estudio_detalle = {
          estudio_clinico: this.state.estudio_clinico,
          visita: this.state.visita,
        };
      }

      let informacion_femenina = null;
      if (this.state.gender.toUpperCase() == "FEMENINO") {
        informacion_femenina = {
          menopausia: this.state.menopause,
          menstruacion: this.state.menstruationPatientDate,
          planificacion: this.state.planningMethod,
          embarazo: this.state.pregnancyTest,
        };
      }

      const dataSend = {
        tipDoc: this.state.typeOfDocument,
        numDoc: this.state.document_number,
        ape1: lastNames[0],
        ape2: lastNames[1],
        nombres: this.state.name,
        sexo: this.state.gender,
        fec_nacimiento: moment(this.state.birthday).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        direccion: {
          id_pais: this.state.country,
          id_departamento: this.state.department,
          departamento: this.state.departments.filter(
            (department) =>
              department.depcod.toString() === this.state.department.toString()
          )[0].depnom,
          ciudad: this.state.cities.filter(
            (city) => city.ciucod.toString() === this.state.city.toString()
          )[0].ciunom,
          id_ciudad: this.state.city,
          direccion: this.state.address,
        },
        telefono1: this.state.telephone1,
        telefono2: this.state.telephone2,
        celular: this.state.cellphone,
        correo: this.state.email,
        e_civil: "",
        id_etnia: null,
        id_raza: null,
        id_regimen: this.state.regime,
        tipo_sangre: "",
        fecha: moment(new Date()).format("YYYY-MM-DD"),
        title: titulo,
        id: this.props.dataEvent.id,
        id_espacio: this.props.dataEvent.espacio,
        id_agenda: this.props.dataEvent.id_agenda, //this.props.dataEvent.id_agenda != undefined? this.props.dataEvent.id_agenda: this.state.professionals.filter((professional)=> { return professional.id_profesional == this.state.professional})[0].id_agenda_activa,
        id_historia: this.state.history,
        id_tercero: this.state.costumer,
        id_plan: this.state.plan,
        servicio: this.state.activitiesAppointment,
        fecha_deseada: this.state.possibleDate,
        fecha_solicitud: this.state.solicitDate,
        estudio_detalle: estudio_detalle,
        observacion: this.state.observation,
        zona: this.state.zone,
        tipo_consulta: this.state.typeConsult.id_tipo_consulta,
        peso: this.state.weight,
        talla: this.state.height,
        imc: this.state.imc,
        requerimientos_especiales: this.state.requerimientos_especiales,
        caidas: this.state.caidas,
        citas_adicionales: this.state.confirmedAdditionalAppointments,
        informacion_femenina: informacion_femenina,
        nombre_fase: this.state.nameInitialPhase,
        primera_vez: this.state.firstAppointment,
        tipo_cita_agenda: this.state.typeDate,
        id_usuario:
          this.state.user != null && this.state.user != undefined
            ? this.state.user.id_usuario
            : JSON.parse(sessionStorage.getItem("usuario")).id_usuario,
        fecha_agendada_cita: new Date(),
        idSede: this.state.workplaceSelected,
        idsJornadas: organizedIdsSelectedStages,
      };

      fetch(process.env.REACT_APP_PUBLIC_URL + "cita/create-paciente-nuevo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      })
        .then((response) => {
          if (response.status != 500 && response.status != 403) {
            return response.text();
          } else {
            throw new Error("No se creo el paciente ni la cita");
          }
        })
        .then((data) => {
          this.setState({
            openAlert: true,
            modalAlert: {
              title: "Exitoso",
              message: "Paciente y Cita creados correctamente",
              color: "success",
            },
            priority: "Reservada",
            id_appointment: 1,
            loadingProcess: false,
          });
        })
        .catch((error) => {
          console.error("Error:", error);
          this.setState({
            openAlert: true,
            modalAlert: {
              title: "Error",
              message:
                "Ha ocurrido un error registrando la Cita, es posible que esta Jornada ya este ocupada por otro paciente",
              color: "danger",
            },
            loadingProcess: false,
          });
        });
    });
  };

  handlerChangeVisits = async (value) => {
    this.setState({ visita: value });
  };

  handlerServiceChangeDate = (value) => {
    this.setState({ serviceChangeDate: value });
  };

  //Valida el Tipo de Consulta
  validateTypeConsult = (value) => {
    switch (value) {
      case 1:
        return "01";
      case 2:
        return "02";
      case 3:
        return "03";
      case 4:
        return "04";
      case 5:
        return "05";
      case 6:
        return "06";
      case 7:
        return "07";
      case 8:
        return "08";
      case 9:
        return "09";
      case 10:
        return "10";
    }
  };

  //Esteban Londoño Ospina 26/11/2021
  //Se validan los Apellidos del Paciente desde el Servidor
  validateLastNamePatientFromServer = (ape1, ape2) => {
    let last_name = "";
    if (ape1 != null) {
      last_name = last_name + ape1;
    }
    if (ape2 != null) {
      last_name = last_name + " " + ape2;
    }
    return last_name;
  };

  getImc = () => {
    var gImc = 0;
    if (this.state.weight === "" || this.state.height === "") {
      return "";
    } else {
      var w = parseInt(this.state.weight);
      var h = parseFloat(this.state.height) / 100;
      gImc = (w / (h * h)).toFixed(2);
      this.setState({ imc: gImc });
    }
  };

  dataCaidaSet = (caida) => {
    this.setState({ caidas: caida });
  };

  dataReqEsp = (reqEsp) => {
    this.setState({ requerimientos_especiales: reqEsp });
  };

  //Realiza la validacion de que no se mezclen consultas con procedimientos antes de guardar para evitar Glosas de Factura con SURA!
  validatedQuerysAndProcedures = () => {
    let activities = this.state.activitiesAppointment;
    let querysActivities = activities.some((act) => act.id_rips_concepto == 1);
    let proceduresActivites = activities.some(
      (act) => act.id_rips_concepto != 1
    );
    if (querysActivities == true && proceduresActivites == true) {
      return false;
    } else {
      return true;
    }
  };

  //Confirmacion de Citas adicionales a traves de la Modal Plus
  handlerConfirmedAdditionalAppointments = (value) => {
    if (value.detalle_servicio.requiere_multicitas != true) {
      this.setState({
        confirmedAdditionalAppointments: [
          ...this.state.confirmedAdditionalAppointments.filter(
            (confCita) => value.id_servicio != confCita.id_servicio
          ),
          value,
        ],
      });
    } else {
      this.setState({
        confirmedAdditionalAppointments: [
          ...this.state.confirmedAdditionalAppointments,
          value,
        ],
      });
    }
  };

  completeHandlerConfirmedAddionalAppointments = (arr) => {
    //Se utiliza cuando se elimina una cita preconfirmada
    this.setState({ confirmedAdditionalAppointments: arr });
  };

  updateAdditionalPatientInformation = async () => {
    let informacion_femenina = null;
    if (this.state.gender.toUpperCase() == "FEMENINO") {
      informacion_femenina = {
        menopausia: this.state.menopause,
        menstruacion: this.state.menstruationPatientDate,
        planificacion: this.state.planningMethod,
        embarazo: this.state.pregnancyTest,
      };
    }
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "paciente/actualizar-informacion-femenina",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify({
          id_historia: this.state.id_history,
          informacion_femenina: informacion_femenina,
        }),
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ womanInformationEdit: false });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  updateObservation = async (id_cita) => {
    let dataSend = {
      id_cita,
      observacion: this.state.observation,
    };

    await fetch(process.env.REACT_APP_PUBLIC_URL + "cita/update-observ", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(dataSend),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ observationFieldEdit: false });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  changeNameInitialPhase = (nameInitialPhase) => {
    this.setState({ nameInitialPhase: nameInitialPhase });
  };

  //Esteban Londoño Ospina 24/06/2022
  //Cada vez que se Cambia el Documento del Paciente o se Agregan/Quitan servicios, valida si hay o no cobro.
  validateControlAppointment = async () => {
    if (
      this.state.history != null &&
      this.state.history != undefined &&
      this.state.history != ""
    ) {
      let existControlQuery = this.state.activitiesAppointment.some(
        (ser) => ser.codigo.substr(0, 4) == "8903"
      );
      if (existControlQuery == true) {
        let dataSend = {
          id_historia: this.state.history,
          servicios: this.state.activitiesAppointment,
          fecha_inicio: this.state.date,
          id_agenda: this.props.dataEvent.id_agenda,
        };
        await fetch(
          process.env.REACT_APP_PUBLIC_URL + "cita/validar-cita-control",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: "Bearer " + sessionStorage.getItem("token"),
            },
            body: JSON.stringify(dataSend),
          }
        )
          .then((response) => {
            if (response.status != 500 && response.status != 403) {
              return response.json();
            } else {
              throw new Error("Ha ocurrido un error con la Validación");
            }
          })
          .then((data) => {
            this.setState({ exemptFromPayment: data.excento });
          })
          .catch((error) => {
            this.setState({ exemptFromPayment: false });
          });
      } else {
        this.setState({ exemptFromPayment: false });
      }
    } else {
      this.setState({ exemptFromPayment: false });
    }
  };

  handlerOpenModalAlergies = (event) => {
    this.setState({ openModalAlergies: event });
  };

  validateShowInfoClinic = () => {
    let clinica = JSON.parse(sessionStorage.getItem("clinica"));

    this.setState({
      showSpecialReq: clinica.hasOwnProperty("solicitar_req_especiales")
        ? clinica.solicitar_req_especiales
        : false,
      showFeminineInfo: clinica.hasOwnProperty("info_femenina")
        ? clinica.info_femenina
        : false,
      showFallingRisks: clinica.hasOwnProperty("solicitar_riesdo_caida")
        ? clinica.solicitar_riesdo_caida
        : false,
      verifyPaymentServiceControl: clinica.hasOwnProperty(
        "cobro_consulta_control"
      )
        ? clinica.cobro_consulta_control
        : false,
      numDaysToCheckPayment: clinica.hasOwnProperty(
        "nro_dias_validar_cobro_cita"
      )
        ? clinica.nro_dias_validar_cobro_cita
        : false,
      manageStagesAgenda: clinica.hasOwnProperty("administrar_agenda")
        ? clinica.administrar_agenda
        : false,
    });
  };

  handlerWorkplace = (id) => {
    this.setState({ workplaceSelected: id });
  };

  handleCloseModal = () => {
    this.setState({ isModalOpenRoom: false });
  };

  //#endregion
  render() {
    var { handlerClose, openEvent, classes } = this.props;
    return (
      <React.Fragment>
        {this.state.openAlert ? (
          <ModalMessage
            color={this.state.modalAlert.color}
            title={this.state.modalAlert.title}
            message={this.state.modalAlert.message}
            modal={this.state.openAlert}
            toggle={() => {
              if (
                this.state.modalAlert.color != "warning" &&
                this.state.modalAlert.color != "danger"
              ) {
                this.setState({ openAlert: !this.state.openAlert }, () => {
                  this.props.reload(
                    this.props.selectedDay,
                    this.props.professional,
                    this.props.typeAppointment,
                    this.props.atentionAgenda
                  );
                  this.props.handlerClose(false);
                });
              } else {
                this.setState({
                  c: false,
                  modalAlert: { title: "", message: "", color: "info" },
                });
              }
            }}
            onOk={() => {
              if (this.state.updateData) {
                this.setState({
                  openAlert: !this.state.openAlert,
                  updateData: false,
                });
              } else {
                this.setState({ openAlert: !this.state.openAlert }, () => {
                  if (this.state.modalAlert.color == "success") {
                    this.props.reload(
                      this.props.selectedDay,
                      this.props.professional,
                      this.props.typeAppointment,
                      this.props.atentionAgenda
                    );
                    this.props.handlerClose(false);
                  }
                });
              }
            }}
          />
        ) : null}
        <Modal
          open={openEvent}
          onClose={() => {
            handlerClose(false);
          }}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ zIndex: 1000 }}
          disableEnforceFocus={true}
        >
          <Row className="paperAppointment-default">
            <div className="subtitle-mod">
              <h4>Asignación de Cita Paciente</h4>
            </div>
            <div>
              <Row>
                <Col md={8} xs={12}>
                  <div
                    style={{
                      border: "1px solid #B2B8BF",
                      marginTop: 5,
                      borderRadius: 5,
                    }}
                  >
                    <div className="titles-segment-appointment-mod">
                      <h6>Datos de la Cita</h6>
                    </div>
                    <Row className="row-default-space-modal-appointment">
                      <Col xs={12} md={4}>
                        <FormControl
                          className="medical-material-form__field field-appointment-mod"
                          InputLabelProps={{
                            style: { color: "#646777" },
                            shrink: true,
                          }}
                          error={
                            this.state.errors.hasOwnProperty("professional")
                              ? this.state.errors.professional !== ""
                              : false
                          }
                        >
                          <InputLabel
                            shrink={true}
                            id="professional-simple-select-label"
                          >
                            Profesional Dr(a).
                          </InputLabel>
                          <Select
                            labelId="professional-simple-select-label"
                            id="professional-simple-select"
                            value={this.state.professional}
                            onChange={(event) => {
                              this.handlerProfessional(event.target.value);
                            }}
                            disabled={this.props.hasOwnProperty("dataEvent")}
                            error={
                              this.state.errors.hasOwnProperty("professional")
                                ? this.state.errors.professional !== ""
                                : false
                            }
                            classes={{
                              disabled: classes.disabled,
                            }}
                          >
                            {this.state.professionals.map(
                              (professional, index) => {
                                return (
                                  <MenuItem
                                    value={professional.id_profesional}
                                    key={professional.id_profesional}
                                  >{`${professional.nombres} ${professional.apellido1} ${professional.apellido2}`}</MenuItem>
                                );
                              }
                            )}
                          </Select>
                          <FormHelperText>
                            {this.state.errors.professional}
                          </FormHelperText>
                        </FormControl>
                      </Col>
                      <Col xs={12} md={4}>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                          <ThemeProvider theme={defaultMaterialTheme}>
                            <DatePicker
                              className="medical-material-form__field field-appointment-mod"
                              InputLabelProps={{
                                style: { color: "#646777" },
                                shrink: true,
                              }}
                              variant="inline"
                              label="Fecha"
                              value={this.state.date}
                              onChange={(date) => {
                                this.handlerDate(new Date(date));
                              }}
                              disabled={!this.state.dateEnable}
                              format="DD/MM/yyyy"
                              animateYearScrolling
                              InputProps={{
                                classes: {
                                  disabled: classes.disabled,
                                },
                              }}
                            />
                          </ThemeProvider>
                        </MuiPickersUtilsProvider>
                      </Col>
                      <Col xs={12} md={4}>
                        <div className="flex-spac-bet-elem">
                          <MuiPickersUtilsProvider utils={MomentUtils}>
                            <ThemeProvider theme={defaultMaterialTheme}>
                              <TimePicker
                                className="medical-material-form__field field-appointment-mod"
                                InputLabelProps={{
                                  style: { color: "#646777" },
                                  shrink: true,
                                }}
                                label="Hora"
                                value={this.state.date}
                                disabled={!this.state.dateEnable}
                                animateYearScrolling
                                InputProps={{
                                  classes: {
                                    disabled: classes.disabled,
                                  },
                                }}
                                onChange={(date) => {
                                  this.handlerDate(new Date(date));
                                }}
                              />
                            </ThemeProvider>
                          </MuiPickersUtilsProvider>
                          {this.props.dataEvent.id_cita != null &&
                          this.props.dataEvent.id_cita != undefined &&
                          this.props.dataEvent.id_cita != "" &&
                          this.state.forma_cita == 1 ? (
                            <Tooltip title="Reagendar Cita">
                              <IconButton
                                aria-label="upload picture"
                                component="span"
                                onClick={() => {
                                  this.setState({
                                    openModalChangingAppointment: true,
                                  });
                                }}
                              >
                                <CalendarTodayRounded />
                              </IconButton>
                            </Tooltip>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
                {this.state.listTipos.includes("3") ? (
                  <Col md={4} xs={12}>
                    <div
                      style={{
                        border: "1px solid #B2B8BF",
                        marginTop: 5,
                        borderRadius: 5,
                      }}
                    >
                      <div className="titles-segment-appointment-mod">
                        <h6>Datos Adicionales</h6>
                      </div>
                      <Row className="row-default-space-modal-appointment">
                        <Col>
                          <TextField
                            id="peso-standard"
                            label="Peso "
                            placeholder="(2kg)"
                            type="number"
                            className="medical-material-form__field"
                            InputLabelProps={{
                              style: { color: "#646777" },
                              shrink: true,
                            }}
                            value={this.state.weight}
                            onChange={(event) => {
                              this.setState(
                                { weight: event.target.value },
                                () => {
                                  this.getImc();
                                }
                              );
                            }}
                            error={
                              this.state.errors.hasOwnProperty("weight")
                                ? this.state.errors.weight !== ""
                                : false
                            }
                            helperText={this.state.errors.weight}
                            disabled={
                              this.props.dataEvent.id_cita !==
                              this.props.dataEvent.id_cita
                            }
                          />
                        </Col>
                        <Col>
                          <TextField
                            id="talla-standard"
                            label="Talla "
                            type="number"
                            placeholder="(20cm)"
                            className="medical-material-form__field"
                            InputProps={{ inputProps: { min: 20, max: 700 } }}
                            InputLabelProps={{
                              style: { color: "#646777" },
                              shrink: true,
                            }}
                            value={this.state.height}
                            onChange={(event) => {
                              this.setState(
                                { height: event.target.value },
                                () => {
                                  this.getImc();
                                }
                              );
                            }}
                            error={
                              this.state.errors.hasOwnProperty("height")
                                ? this.state.errors.height !== ""
                                : false
                            }
                            helperText={this.state.errors.height}
                            disabled={
                              this.props.dataEvent.id_cita !==
                              this.props.dataEvent.id_cita
                            }
                          />
                        </Col>
                        <Col>
                          <TextField
                            id="imc"
                            label="IMC "
                            placeholder="IMC"
                            type="number"
                            className="medical-material-form__field"
                            InputLabelProps={{
                              style: { color: "#646777" },
                              shrink: true,
                            }}
                            value={this.state.imc}
                            disabled={true}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                ) : null}
              </Row>

              <div
                style={{
                  border: "1px solid #B2B8BF",
                  marginTop: 5,
                  borderRadius: 5,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="titles-segment-appointment-mod">
                    <h6>Datos del Paciente</h6>
                  </div>
                  <div>
                    <span style={{ margin: "2px 5px" }}>
                      {this.state.ageLetters !== ""
                        ? "Edad: " + this.state.ageLetters
                        : ""}
                    </span>
                  </div>
                </div>
                <Row className="row-default-space-modal-appointment">
                  <Col>
                    <FormControl
                      className={
                        classes.date +
                        " medical-material-form__field field-appointment-mod"
                      }
                      InputLabelProps={{
                        style: { color: "#646777" },
                        shrink: true,
                      }}
                      error={
                        this.state.errors.hasOwnProperty("typeOfDocument")
                          ? this.state.errors.typeOfDocument !== ""
                          : false
                      }
                    >
                      <InputLabel
                        shrink={true}
                        required
                        id="demo-simple-select-label"
                      >
                        Tip. Documento
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="id-simple-select"
                        value={this.state.typeOfDocument}
                        disabled={
                          (this.state.patienteExist ||
                            this.props.dataEvent.id_cita !== "") &&
                          this.state.updateData == false
                        }
                        onChange={(event) => {
                          this.handleTypeDocument(event);
                        }}
                        error={
                          this.state.errors.hasOwnProperty("typeOfDocument")
                            ? this.state.errors.typeOfDocument !== ""
                            : false
                        }
                      >
                        <MenuItem
                          className="material-form__option"
                          key={1}
                          value={"TI"}
                        >
                          TI-Tarjeta de Identidad
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={2}
                          value={"CC"}
                        >
                          CC-Cedula de Ciudadania
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={3}
                          value={"PA"}
                        >
                          PA-Pasaporte
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={4}
                          value={"RC"}
                        >
                          RC-Registro Civil
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={5}
                          value={"CE"}
                        >
                          CE-Cedula de Extranjeria
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={6}
                          value={"MS"}
                        >
                          MS-Menor sin Identificación
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={7}
                          value={"AS"}
                        >
                          AS-Adulto sin Identificación
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={8}
                          value={"SC"}
                        >
                          SC-Salvo Conducto
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={9}
                          value={"CD"}
                        >
                          CD-Carnet Diplomatico
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={10}
                          value={"CN"}
                        >
                          CN-Certificado de Nacido Vivo
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={11}
                          value={"SC"}
                        >
                          SC-Salvoconducto
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={12}
                          value={"PE"}
                        >
                          PE-Permiso Especial de Permanencia
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={13}
                          value={"PT"}
                        >
                          PT-Permiso por Protección Temporal
                        </MenuItem>
                        <MenuItem
                          className="material-form__option"
                          key={14}
                          value={"SI"}
                        >
                          SI-Sin Identificación
                        </MenuItem>
                      </Select>
                      <FormHelperText>
                        {this.state.errors.typeOfDocument}
                      </FormHelperText>
                    </FormControl>
                  </Col>
                  <Col>
                    <TextField
                      className="medical-material-form__field field-appointment-mod"
                      InputLabelProps={{
                        style: { color: "#646777" },
                        shrink: true,
                      }}
                      required
                      id="id-standard-required"
                      label="No. Documento"
                      type="number"
                      value={this.state.document_number}
                      onChange={(e) => {
                        this.handlerDocumentNumber(e);
                        this.validationDocLength(e.target.value);
                      }}
                      onBlur={(e) => {
                        this.validateControlAppointment();
                      }}
                      error={
                        this.state.errors.hasOwnProperty("document_number")
                          ? this.state.errors.document_number !== ""
                          : false
                      }
                      helperText={this.state.errors.document_number}
                      disabled={this.props.dataEvent.id_cita !== ""}
                      InputProps={{
                        classes: {
                          disabled: classes.disabled,
                        },
                      }}
                    />
                  </Col>
                  <Col>
                    <TextField
                      className="medical-material-form__field field-appointment-mod"
                      InputLabelProps={{
                        style: { color: "#646777", width: "100%" },
                        shrink: true,
                      }}
                      required
                      id="name-standard-required"
                      label="Nombre"
                      type="text"
                      value={this.state.name}
                      onChange={(e) => {
                        this.handlerName(e);
                      }}
                      error={
                        this.state.errors.hasOwnProperty("name")
                          ? this.state.errors.name !== ""
                          : false
                      }
                      helperText={this.state.errors.name}
                      disabled={this.state.disableInput}
                      InputProps={{
                        classes: {
                          disabled: classes.disabled,
                        },
                      }}
                    />
                  </Col>
                  <Col>
                    <TextField
                      className="medical-material-form__field field-appointment-mod"
                      InputLabelProps={{
                        style: { color: "#646777", width: "100%" },
                        shrink: true,
                      }}
                      required
                      id="last-name-standard-required"
                      label="Apellidos"
                      type="text"
                      value={this.state.last_name}
                      onChange={(e) => {
                        this.handlerLastName(e);
                      }}
                      error={
                        this.state.errors.hasOwnProperty("last_name")
                          ? this.state.errors.last_name !== ""
                          : false
                      }
                      helperText={
                        this.state.errors.last_name ||
                        this.props.dataEvent.id_cita !== ""
                      }
                      disabled={this.state.disableInput}
                      InputProps={{
                        classes: {
                          disabled: classes.disabled,
                        },
                      }}
                    />
                  </Col>
                  <Col>
                    <div className="flex-spac-bet-elem">
                      <TextField
                        className="medical-material-form__field field-appointment-mod"
                        InputLabelProps={{
                          style: { color: "#646777", width: "100%" },
                          shrink: true,
                        }}
                        required
                        id="email-standard-required"
                        label="E-mail"
                        type="email"
                        value={this.state.email}
                        onChange={this.handlerEmail}
                        error={
                          this.state.errors.hasOwnProperty("email")
                            ? this.state.errors.email !== ""
                            : false
                        }
                        helperText={
                          this.state.errors.email ||
                          this.props.dataEvent.id_cita !== ""
                        }
                        disabled={this.state.disableInput}
                        InputProps={{
                          classes: {
                            disabled: classes.disabled,
                          },
                        }}
                      />

                      {/* {!this.state.disableInput ?
                                                <FormControlLabel
                                                    style={{ fontSize: '1em' }}
                                                    className='field-appointment-mod'
                                                    control={
                                                        <Checkbox disabled={this.state.disableInput} color="primary" size='small'
                                                            onChange={(event) => {
                                                                if (event.target.checked) {
                                                                    this.setState({ email: 'NOTIENE@CORREO.COM' });
                                                                } else {
                                                                    this.setState({ email: ' ' });
                                                                }
                                                            }
                                                            }
                                                        />} label="No tiene" />
                                                : null} */}
                    </div>
                  </Col>
                  {this.state.patienteExist ||
                  this.props.dataEvent.id_cita !== "" ? (
                    <Col>
                      <Tooltip title="Editar datos del Paciente">
                        <IconButton
                          aria-label="upload picture"
                          component="span"
                          onClick={() => {
                            this.setState({
                              disableInput: !this.state.disableInput,
                              updateData: true,
                            });
                          }}
                        >
                          <EditOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Col>
                  ) : null}
                </Row>
                <Row className="row-default-space-modal-appointment">
                  <Col>
                    <TextField
                      className="medical-material-form__field field-appointment-mod"
                      InputLabelProps={{
                        style: { color: "#646777", width: "100%" },
                        shrink: true,
                      }}
                      id="tel-standard-required-1"
                      label="Número de telefono 1"
                      type="number"
                      value={this.state.telephone1}
                      onChange={this.handlerTelephone1}
                      disabled={this.state.disableInput}
                      /* error={this.state.errors.hasOwnProperty("telephone1") ? this.state.errors.telephone1 !== "" : false}
                                            helperText={this.state.errors.telephone1} */
                      error={
                        this.state.errors.hasOwnProperty("telephone1")
                          ? this.state.errors.telephone1 !== ""
                          : false
                      }
                      helperText={this.state.errors.telephone1}
                      InputProps={{
                        classes: {
                          disabled: classes.disabled,
                        },
                      }}
                    />
                  </Col>
                  <Col>
                    <TextField
                      required
                      className="medical-material-form__field field-appointment-mod"
                      InputLabelProps={{
                        style: { color: "#646777" },
                        shrink: true,
                      }}
                      id="cellphone-standard-required"
                      label="Número de celular"
                      type="number"
                      value={this.state.cellphone}
                      onChange={this.handlerCellphone}
                      disabled={this.state.disableInput}
                      InputProps={{
                        classes: {
                          disabled: classes.disabled,
                        },
                      }}
                      error={
                        this.state.errors.hasOwnProperty("cellphone")
                          ? this.state.errors.cellphone !== ""
                          : false
                      }
                      helperText={this.state.errors.cellphone}
                    />
                  </Col>
                  {
                    <Col>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <ThemeProvider theme={defaultMaterialTheme}>
                          <KeyboardDatePicker
                            //className="medical-material-form__field field-appointment-mod"
                            InputLabelProps={{
                              style: { color: "#646777", width: "100%" },
                              shrink: true,
                            }}
                            variant="inline"
                            disableFuture
                            label="Fecha de Nacimiento"
                            views={["year", "month", "date"]}
                            value={this.state.birthday}
                            onChange={(date) => {
                              if (date !== null) {
                                if (date._isValid) {
                                  this.handlerBirthDate(moment(new Date(date)));
                                } else {
                                  this.handlerBirthDate(
                                    moment(new Date(date._i))
                                  );
                                }
                              } else {
                                this.handlerBirthDate(null);
                              }
                            }}
                            animateYearScrolling
                            format="DD-MM-YYYY"
                            error={
                              this.state.errors.hasOwnProperty("birthday")
                                ? this.state.errors.birthday !== ""
                                : false
                            }
                            helperText={this.state.errors.birthday}
                            disabled={this.state.disableInput}
                            autoOk={true}
                            InputProps={{
                              classes: {
                                disabled: classes.disabled,
                              },
                            }}
                          />
                        </ThemeProvider>
                      </MuiPickersUtilsProvider>
                    </Col>
                  }
                  <Col>
                    <FormControl
                      className={
                        classes.date +
                        " medical-material-form__field field-appointment-mod"
                      }
                      InputLabelProps={{
                        style: { color: "#646777", width: "100%" },
                        shrink: true,
                      }}
                      error={
                        this.state.errors.hasOwnProperty("gender")
                          ? this.state.errors.gender !== ""
                          : false
                      }
                    >
                      <InputLabel
                        shrink={true}
                        required
                        id="demo-simple-select-label"
                      >
                        Genero
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="id-simple-select"
                        defaultValue={null}
                        value={this.state.gender}
                        disabled={this.state.disableInput}
                        onChange={(event) => {
                          this.handlerGender(event.target.value);
                        }}
                        error={
                          this.state.errors.hasOwnProperty("gender")
                            ? this.state.errors.gender !== ""
                            : false
                        }
                      >
                        <MenuItem key={1} value={"Masculino"}>
                          Masculino
                        </MenuItem>
                        <MenuItem key={2} value={"Femenino"}>
                          Femenino
                        </MenuItem>
                        <MenuItem key={3} value={"Binario"}>
                          Binario
                        </MenuItem>
                      </Select>
                      <FormHelperText>
                        {this.state.errors.gender}
                      </FormHelperText>
                    </FormControl>
                  </Col>
                  {!!this.state.workplaces.length && (
                    <Col>
                      <TextField
                        select
                        name="workplaceSelected"
                        className="medical-material-form__field field-appointment-mod"
                        InputLabelProps={{
                          style: { color: "#646777" },
                          shrink: true,
                        }}
                        id="workplace-standard"
                        label="Sede"
                        value={this.state.workplaceSelected}
                        onChange={(event) => {
                          this.handlerWorkplace(event.target.value);
                        }}
                        disabled={
                          this.props.dataEvent.id_cita !== "" ||
                          this.state.workplaces.length === 1
                        }
                        InputProps={{
                          classes: {
                            disabled: classes.disabled,
                          },
                        }}
                        error={
                          this.state.errors.hasOwnProperty("workplaceSelected")
                            ? this.state.errors.workplaceSelected !== ""
                            : false
                        }
                        helperText={this.state.errors.workplaceSelected}
                      >
                        {this.state.workplaces.map((workplace) => (
                          <MenuItem
                            key={workplace.id_sede}
                            value={workplace.id_sede}
                          >
                            {workplace.nombre}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Col>
                  )}
                  {this.state.updateData ? (
                    <Col>
                      <Tooltip title="Actualizar Paciente">
                        <IconButton
                          aria-label="upload picture"
                          component="span"
                          onClick={() => {
                            this.updatePatient();
                          }}
                        >
                          <SaveIcon />
                        </IconButton>
                      </Tooltip>
                    </Col>
                  ) : null}
                </Row>
                <Row className="row-default-space-modal-appointment">
                  <Col>
                    <TextField
                      className="medical-material-form__field field-appointment-mod"
                      InputLabelProps={{
                        style: { color: "#646777", width: "100%" },
                        shrink: true,
                      }}
                      label="País"
                      id="id-simplepais-select"
                      select
                      value={this.state.country}
                      disabled={this.state.disableInput}
                      onChange={(event) => {
                        this.handlerCountry(event.target.value);
                      }}
                      error={
                        this.state.errors.hasOwnProperty("country")
                          ? this.state.errors.country !== ""
                          : false
                      }
                      helperText={this.state.errors.country}
                    >
                      {this.state.countries.map((country) => {
                        return (
                          <MenuItem
                            className="material-form__option"
                            key={country.paicod}
                            value={country.paicod}
                          >
                            {country.painom}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Col>
                  <Col>
                    <TextField
                      required
                      className="medical-material-form__field field-appointment-mod"
                      InputLabelProps={{
                        style: { color: "#646777", width: "100%" },
                        shrink: true,
                      }}
                      label="Departamento"
                      id="id-simpledep-select"
                      select
                      disabled={this.state.disableInput}
                      value={this.state.department}
                      onChange={(event) => {
                        this.handlerDepartment(event.target.value);
                      }}
                      error={
                        this.state.errors.hasOwnProperty("department")
                          ? this.state.errors.department !== ""
                          : false
                      }
                      helperText={this.state.errors.department}
                    >
                      {this.state.departments.map((department) => {
                        return (
                          <MenuItem
                            className="material-form__option"
                            key={department.id}
                            value={department.depcod}
                          >
                            {department.depnom}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Col>
                  <Col>
                    <TextField
                      required
                      className="medical-material-form__field field-appointment-mod"
                      InputLabelProps={{
                        style: { color: "#646777", width: "100%" },
                        shrink: true,
                      }}
                      label="Ciudad"
                      id="id-simplecity-select"
                      select
                      disabled={this.state.disableInput}
                      value={this.state.city}
                      onChange={(event) => {
                        this.handlerCity(event.target.value);
                      }}
                      error={
                        this.state.errors.hasOwnProperty("city")
                          ? this.state.errors.city !== ""
                          : false
                      }
                      helperText={this.state.errors.city}
                    >
                      {this.state.cities.map((city) => {
                        return (
                          <MenuItem
                            className="material-form__option"
                            key={city.id}
                            value={city.ciucod}
                          >
                            {city.ciunom}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Col>
                  <Col>
                    <TextField
                      required
                      className="medical-material-form__field field-appointment-mod"
                      InputLabelProps={{
                        style: { color: "#646777", width: "100%" },
                        shrink: true,
                      }}
                      id="address-standard-required"
                      label="Dirección"
                      type="text"
                      value={this.state.address.toUpperCase()}
                      disabled={this.state.disableInput}
                      onChange={(e) => {
                        this.handlerAddress(e.target.value);
                      }}
                      error={
                        this.state.errors.hasOwnProperty("address")
                          ? this.state.errors.address !== ""
                          : false
                      }
                      helperText={this.state.errors.address}
                    />
                  </Col>
                  <Col>
                    <FormControl
                      className={
                        classes.date +
                        " medical-material-form__field field-appointment-mod"
                      }
                      InputLabelProps={{
                        style: { color: "#646777", width: "100%" },
                        shrink: true,
                      }}
                    >
                      <InputLabel
                        shrink={true}
                        required
                        id="demo-simple-select-label"
                      >
                        Zona
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="id-simple-select"
                        defaultValue={null}
                        value={this.state.zone}
                        disabled={this.state.disableInput}
                        onChange={(event) => {
                          this.handlerZone(event.target.value);
                        }}
                      >
                        <MenuItem key={1} value={"R"}>
                          RURAL
                        </MenuItem>
                        <MenuItem key={2} value={"U"}>
                          URBANA
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Col>
                  <Col>
                    <FormControl
                      className={
                        classes.date +
                        " medical-material-form__field field-appointment-mod"
                      }
                      InputLabelProps={{
                        style: { color: "#646777" },
                        shrink: true,
                      }}
                      error={
                        this.state.errors.hasOwnProperty("poblacionVulnerable")
                          ? this.state.errors.poblacionVulnerable !== ""
                          : false
                      }
                    >
                      <InputLabel
                        shrink={true}
                        required
                        id="demo-simple-select-label"
                      >
                        Población vulnerable
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="id-simple-select"
                        //defaultValue={null}
                        value={this.state.poblacionVulnerable}
                        disabled={this.state.disableInput}
                        onChange={(event) => {
                          this.handlePoblacionVulnerable(event.target.value);
                        }}
                        error={
                          this.state.errors.hasOwnProperty(
                            "poblacionVulnerable"
                          )
                            ? this.state.errors.poblacionVulnerable !== ""
                            : false
                        }
                      >
                        {this.state.poblaciones.map((poblacion) => {
                          return (
                            <MenuItem
                              key={poblacion.id_poblacion_vulnerable}
                              value={poblacion.id_poblacion_vulnerable}
                            >
                              {poblacion.nombre}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      <FormHelperText>
                        {this.state.errors.poblacionVulnerable}
                      </FormHelperText>
                    </FormControl>
                  </Col>
                </Row>
                <Row className="row-default-space-modal-appointment">
                  {this.state.patienteExist ||
                  this.props.dataEvent.id_cita !== "" ? (
                    <Col>
                      <div
                        className="tooltip-alergies"
                        style={{
                          justifySelf: "flex-end",
                          alignSelf: "center",
                          marginLeft: "auto",
                          marginRight: "1em",
                        }}
                      >
                        <Tooltip title="Alergias">
                          <IconButton
                            aria-label="launch"
                            color="inherit"
                            style={{
                              padding: 2,
                              backgroundColor: "#FF5B1D",
                              width: "1em",
                              height: "1em",
                            }}
                            disabled={
                              this.state.patienteExist ||
                              this.props.dataEvent.id_cita !== ""
                                ? false
                                : true
                            }
                            onClick={() => {
                              this.handlerOpenModalAlergies(
                                !this.state.openModalAlergies
                              );
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faDisease}
                              style={{
                                color: "#FFFFFF",
                                width: "0.8em",
                                height: "0.8em",
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </Col>
                  ) : null}
                </Row>
              </div>

              {this.state.gender.toUpperCase() == "FEMENINO" &&
              calculateAge(this.state.birthday) > 9 &&
              calculateAge(this.state.birthday) < 55 &&
              this.state.showFeminineInfo ? (
                <div
                  style={{
                    border: "1px solid #B2B8BF",
                    marginTop: 5,
                    borderRadius: 5,
                  }}
                >
                  <div className="titles-segment-appointment-mod">
                    <h6>Datos adicionales del Paciente</h6>
                  </div>
                  <Row className="row-default-space-modal-appointment">
                    <Col md={2}>
                      <FormControl
                        className="medical-material-form__field"
                        InputLabelProps={{
                          style: { color: "#646777" },
                          shrink: true,
                        }}
                        style={{ width: "100%" }}
                        error={
                          this.state.errors.hasOwnProperty("menopause")
                            ? this.state.errors.menopause !== ""
                            : false
                        }
                      >
                        <InputLabel
                          shrink={true}
                          id="menopause-simple-select-label"
                        >
                          Tiene Menopausia?
                        </InputLabel>
                        <Select
                          labelId="menopause-simple-select-label"
                          id="menopause-simple-select"
                          value={this.state.menopause}
                          onChange={(event) => {
                            this.setState({ menopause: event.target.value });
                          }}
                          disabled={
                            this.props.dataEvent.id_cita !== "" &&
                            this.state.womanInformationEdit == false
                          }
                          error={
                            this.state.errors.hasOwnProperty("menopause")
                              ? this.state.errors.menopause !== ""
                              : false
                          }
                        >
                          <MenuItem value={true}>SI</MenuItem>
                          <MenuItem value={false}>NO</MenuItem>
                        </Select>
                        <FormHelperText>
                          {this.state.errors.menopause}
                        </FormHelperText>
                      </FormControl>
                    </Col>
                    {this.state.menopause != true ? (
                      <>
                        <Col md={2}>
                          <MuiPickersUtilsProvider utils={MomentUtils}>
                            <ThemeProvider theme={defaultMaterialTheme}>
                              <DatePicker
                                className="medical-material-form__field"
                                InputLabelProps={{
                                  style: { color: "#646777" },
                                  shrink: true,
                                }}
                                variant="inline"
                                label="Ultima Menstruación"
                                views={["year", "month", "date"]}
                                value={this.state.menstruationPatientDate}
                                disabled={
                                  this.props.dataEvent.id_cita !== "" &&
                                  this.state.womanInformationEdit == false
                                }
                                onChange={(date) => {
                                  this.setState({
                                    menstruationPatientDate: date,
                                  });
                                }}
                                animateYearScrolling
                                format="yyyy/MM/DD"
                              />
                            </ThemeProvider>
                          </MuiPickersUtilsProvider>
                        </Col>
                        <Col md={2}>
                          <FormControl
                            className="medical-material-form__field"
                            InputLabelProps={{
                              style: { color: "#646777" },
                              shrink: true,
                            }}
                            style={{ width: "100%" }}
                            error={
                              this.state.errors.hasOwnProperty("planningMethod")
                                ? this.state.errors.planningMethod !== ""
                                : false
                            }
                          >
                            <InputLabel
                              shrink={true}
                              id="planningMethod-simple-select-label"
                            >
                              M. Planificación
                            </InputLabel>
                            <Select
                              labelId="planningMethod-simple-select-label"
                              id="planningMethod-simple-select"
                              value={this.state.planningMethod}
                              onChange={(event) => {
                                this.setState({
                                  planningMethod: event.target.value,
                                });
                              }}
                              disabled={
                                this.props.dataEvent.id_cita !== "" &&
                                this.state.womanInformationEdit == false
                              }
                              error={
                                this.state.errors.hasOwnProperty(
                                  "planningMethod"
                                )
                                  ? this.state.errors.planningMethod !== ""
                                  : false
                              }
                            >
                              <MenuItem value={1}>
                                PÍLDORA ANTICONCEPTIVA
                              </MenuItem>
                              <MenuItem value={2}>
                                SISTEMA INTRAUTERINO - SIU
                              </MenuItem>
                              <MenuItem value={3}>CONDÓN MASCULINO</MenuItem>
                              <MenuItem value={4}>
                                PARCHE ANTICONCEPTIVO
                              </MenuItem>
                              <MenuItem value={5}>
                                ANILLO ANTICONCEPTIVO
                              </MenuItem>
                              <MenuItem value={6}>
                                IMPLANTE ANTICONCEPTIVO
                              </MenuItem>
                              <MenuItem value={7}>
                                INYECCIÓN ANTICONCEPTIVA
                              </MenuItem>
                              <MenuItem value={8}>
                                DISPOSITIVO INTRAUTERINO - DIU
                              </MenuItem>
                              <MenuItem value={9}>CONDÓN FEMENINO</MenuItem>
                              <MenuItem value={10}>DIAFRAGMA</MenuItem>
                              <MenuItem value={11}>CAPUCHÓN CERVICAL</MenuItem>
                              <MenuItem value={12}>ESPONJA</MenuItem>
                              <MenuItem value={13}>ESPERMICIDA</MenuItem>
                              <MenuItem value={14}>ESTERILIZACIÓN</MenuItem>
                              <MenuItem value={15}>
                                PASTILLA DE EMERGENCIA
                              </MenuItem>
                              <MenuItem value={16}>ABSTINENCIA SEXUAL</MenuItem>
                              <MenuItem value={17}>NINGUNA</MenuItem>
                            </Select>
                            <FormHelperText>
                              {this.state.errors.planningMethod}
                            </FormHelperText>
                          </FormControl>
                        </Col>
                        <Col md={2}>
                          <FormControl
                            className="medical-material-form__field"
                            InputLabelProps={{
                              style: { color: "#646777" },
                              shrink: true,
                            }}
                            style={{ width: "100%" }}
                            error={
                              this.state.errors.hasOwnProperty("pregnancyTest")
                                ? this.state.errors.pregnancyTest !== ""
                                : false
                            }
                          >
                            <InputLabel
                              shrink={true}
                              id="pregnancyTest-simple-select-label"
                            >
                              Esta Embarazada?
                            </InputLabel>
                            <Select
                              labelId="pregnancyTest-simple-select-label"
                              id="pregnancyTest-simple-select"
                              value={this.state.pregnancyTest}
                              disabled={
                                this.props.dataEvent.id_cita !== "" &&
                                this.state.womanInformationEdit == false
                              }
                              onChange={(event) => {
                                this.setState({
                                  pregnancyTest: event.target.value,
                                });
                              }}
                              error={
                                this.state.errors.hasOwnProperty(
                                  "pregnancyTest"
                                )
                                  ? this.state.errors.pregnancyTest !== ""
                                  : false
                              }
                            >
                              <MenuItem value={true}>SI</MenuItem>
                              <MenuItem value={false}>NO</MenuItem>
                            </Select>
                            <FormHelperText>
                              {this.state.errors.pregnancyTest}
                            </FormHelperText>
                          </FormControl>
                        </Col>
                      </>
                    ) : null}
                    <Col md={2}>
                      {this.props.dataEvent.id_cita !== "" ? (
                        <>
                          {this.state.womanInformationEdit == false ? (
                            <Tooltip title="Editar datos adicionales del Paciente">
                              <IconButton
                                aria-label="upload picture"
                                component="span"
                                onClick={() => {
                                  this.setState({ womanInformationEdit: true });
                                }}
                              >
                                <EditOutlinedIcon />
                              </IconButton>
                            </Tooltip>
                          ) : (
                            <>
                              <Tooltip title="Actualizar Datos Adicionales">
                                <IconButton
                                  aria-label="upload picture"
                                  component="span"
                                  onClick={() => {
                                    this.updateAdditionalPatientInformation();
                                  }}
                                >
                                  <SaveIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Cancelar Edición">
                                <IconButton
                                  aria-label="upload picture"
                                  component="span"
                                  onClick={() => {
                                    this.setState({
                                      womanInformationEdit: false,
                                    });
                                  }}
                                >
                                  <BlockIcon />
                                </IconButton>
                              </Tooltip>
                            </>
                          )}
                        </>
                      ) : null}
                    </Col>
                  </Row>
                </div>
              ) : null}

              {this.state.manageStagesAgenda && (
                <StagesManagement
                  key={this.props.dataEvent.id_cita}
                  idActualStage={this.props.dataEvent.id}
                  stages={this.state.dayStages}
                  idAgenda={this.props.dataEvent.id_agenda}
                  idCita={this.props.dataEvent.id_cita}
                  servicesSelectedDuration={this.state.servicesSelectedDuration}
                  intervalStage={this.props.dataEvent.intervalo}
                  handlerIdsStagesSelection={this.handlerIdsStagesSelection}
                />
              )}

              {this.state.showHistoryMedico && (
                <div
                  style={{
                    border: "1px solid #B2B8BF",
                    marginTop: 5,
                    borderRadius: 5,
                    maxHeight: 207,
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                >
                  <div className="titles-segment-appointment-mod">
                    <h6>Historial médico</h6>
                  </div>
                  {this.state.listProfesionales.length > 0 ? (
                    this.state.listProfesionales.map((data, index) => (
                      <Row className="row-default-space-modal-appointment">
                        <Col xs={2} key={index}>
                          <MuiPickersUtilsProvider utils={MomentUtils}>
                            <ThemeProvider theme={defaultMaterialTheme}>
                              <DatePicker
                                className="date-profesional-material-form__field"
                                InputLabelProps={{
                                  style: { color: "#646777" },
                                  shrink: true,
                                }}
                                disabled
                                variant="inline"
                                label="Fecha de atención"
                                views={["year", "month", "date"]}
                                value={data.fecha}
                                onChange={(date) => {
                                  this.handleDateAtencion(date);
                                }}
                                animateYearScrolling
                                format="yyyy/MM/DD"
                              />
                            </ThemeProvider>
                          </MuiPickersUtilsProvider>
                        </Col>
                        <Col xs={3}>
                          <TextField
                            className="medical-material-form__field field-appointment-mod"
                            InputLabelProps={{
                              style: { color: "#646777", width: "100%" },
                              shrink: true,
                            }}
                            required
                            label="Profesional"
                            type="text"
                            value={data.profesional}
                            disabled
                          />
                        </Col>
                        <Col xs={2}>
                          <TextField
                            className="medical-material-form__field field-appointment-mod"
                            InputLabelProps={{
                              style: { color: "#646777", width: "100%" },
                              shrink: true,
                            }}
                            required
                            label="Especialidad"
                            type="text"
                            value={data.especialidad}
                            disabled
                          />
                        </Col>
                        {data.servicio.servicios.map((servicio, index) => (
                          <Col xs={5} key={index}>
                            <TextField
                              className="medical-material-form__field field-appointment-mod"
                              InputLabelProps={{
                                style: { color: "#646777", width: "100%" },
                                shrink: true,
                              }}
                              required
                              label="Servicio"
                              type="text"
                              value={servicio.nombre}
                              disabled
                            />
                          </Col>
                        ))}
                      </Row>
                    ))
                  ) : (
                    <p
                      className="titles-segment-appointment-mod"
                      style={{ marginLeft: 12, padding: 10 }}
                    >
                      No se encontraron registros
                    </p>
                  )}
                </div>
              )}

              <div
                style={{
                  border: "1px solid #B2B8BF",
                  marginTop: 5,
                  borderRadius: 5,
                }}
              >
                <div className="titles-segment-appointment-mod">
                  <h6>Datos del Servicio</h6>
                </div>
                <Row className="row-default-space-modal-appointment">
                  <Col md={3}>
                    <FormControl
                      className="medical-material-form__field"
                      InputLabelProps={{
                        style: { color: "#646777" },
                        shrink: true,
                      }}
                      style={{ width: "100%", paddingRight: 10 }}
                      error={
                        this.state.errors.hasOwnProperty("costumer")
                          ? this.state.errors.costumer !== ""
                          : false
                      }
                    >
                      <InputLabel
                        shrink={true}
                        required
                        id="demo-simple-select-label"
                      >
                        Cliente
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={this.state.costumer_data}
                        onChange={(event) => {
                          this.handlerThird_contract(event.target.value);
                        }}
                        error={
                          this.state.errors.hasOwnProperty("costumer")
                            ? this.state.errors.costumer !== ""
                            : false
                        }
                        disabled={this.props.dataEvent.id_cita !== ""}
                      >
                        <MenuItem
                          className="material-form__option"
                          value={null}
                        >
                          Ninguno
                        </MenuItem>
                        {this.state.serter.map((third) => {
                          return (
                            <MenuItem
                              className="material-form__option"
                              key={third.id_tercero}
                              value={third}
                            >
                              {third.nombre_tercero_concatenado}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      <FormHelperText>
                        {this.state.errors.costumer}
                      </FormHelperText>
                    </FormControl>
                  </Col>

                  {
                    //Opciones para Cita por Tercero
                    this.state.forma_cita == 1 ? (
                      <>
                        <Col md={3}>
                          <FormControl
                            className="medical-material-form__field"
                            InputLabelProps={{
                              style: { color: "#646777" },
                              shrink: true,
                            }}
                            style={{ width: "100%" }}
                            error={
                              this.state.errors.hasOwnProperty("plan")
                                ? this.state.errors.plan !== ""
                                : false
                            }
                          >
                            <InputLabel
                              shrink={true}
                              required
                              id="demo-simple-select-label"
                            >
                              Plan
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={this.state.plan}
                              onChange={(event) => {
                                this.setState(
                                  {
                                    loadingAutocomplete: true,
                                  },
                                  () => {
                                    this.handlerPlan(event.target.value);
                                    this.loadActivities(
                                      this.state.costumer,
                                      event.target.value
                                    )
                                      .then((activities) => {
                                        this.setState({
                                          activities: activities,
                                          activity: event.target.value,
                                          loadingAutocomplete: false,
                                        });
                                      })
                                      .catch((error) => {
                                        this.setState({
                                          activities: [],
                                          loadingAutocomplete: false,
                                        });
                                      });
                                  }
                                );
                              }}
                              error={
                                this.state.errors.hasOwnProperty("plan")
                                  ? this.state.errors.plan !== ""
                                  : false
                              }
                              disabled={this.props.dataEvent.id_cita != ""}
                            >
                              <MenuItem
                                className="material-form__option"
                                value={null}
                              >
                                Ninguno
                              </MenuItem>
                              {this.state.plans.map((plan) => {
                                return (
                                  <MenuItem
                                    className="material-form__option"
                                    key={plan.id_plan}
                                    value={plan.id_plan}
                                  >
                                    {plan.nombre}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                            <FormHelperText>
                              {this.state.errors.plan}
                            </FormHelperText>
                          </FormControl>
                        </Col>
                        <Col md={5}>
                          <FormControl
                            style={{
                              width: "100%",
                              position: "relative",
                              left: 10,
                            }}
                            error={
                              this.state.errors.hasOwnProperty(
                                "activitiesAppointment"
                              )
                                ? this.state.errors.activitiesAppointment !== ""
                                : false
                            }
                          >
                            <Autocomplete
                              filterOptions={filterOptions}
                              multiple
                              limitTags={2}
                              id="tags-standard"
                              size="small"
                              loading={this.state.loadingAutocomplete}
                              disabled={
                                this.state.activities.length <= 0 ? true : false
                              }
                              options={this.state.activities}
                              disableCloseOnSelect
                              noOptionsText={
                                "No se encontro Servicios de Salud"
                              }
                              value={this.state.activitiesAppointment}
                              onChange={(event, value, reason, detail) => {
                                if (
                                  this.props.dataEvent.id_cita == "" ||
                                  this.props.dataEvent.id_cita == null
                                ) {
                                  this.handlerActivity(value, detail.option);
                                }
                              }}
                              getOptionLabel={(activity) =>
                                activity.codigo + " " + activity.servicios
                              }
                              renderOption={(activity, { selected }) => (
                                <div
                                  className={
                                    this.props.dataEvent.id_cita != "" ||
                                    this.state.confirmedAdditionalAppointments.some(
                                      (confAdd) =>
                                        confAdd.detalle_servicio.id_servicio ==
                                        activity.id_servicio
                                    )
                                      ? "disabledAutocomplete"
                                      : ""
                                  }
                                  style={{ fontSize: "13px" }}
                                >
                                  <MedicalCheckbox
                                    disabled={
                                      this.props.dataEvent.id_cita != "" ||
                                      this.state.confirmedAdditionalAppointments.some(
                                        (confAdd) =>
                                          confAdd.detalle_servicio
                                            .id_servicio == activity.id_servicio
                                      )
                                        ? true
                                        : false
                                    }
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  />
                                  <b>{activity.codigo}</b> {activity.servicios}
                                </div>
                              )}
                              renderTags={(value, getTagProps) =>
                                value.map((activity, index) => (
                                  <Chip
                                    {...getTagProps({ index })}
                                    size="small"
                                    label={
                                      <EllipsisText>
                                        {activity.codigo} - {activity.servicios}
                                      </EllipsisText>
                                    }
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  className="medical-material-form__field"
                                  InputLabelProps={{
                                    style: { color: "#646777" },
                                    shrink: true,
                                  }}
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <Fragment>
                                        {this.state.loadingAutocomplete ? (
                                          <>
                                            <Spinner
                                              style={{
                                                width: "20px",
                                                height: "20px",
                                                color: "#4CE1B6",
                                              }}
                                              animation="border"
                                            />
                                          </>
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                      </Fragment>
                                    ),
                                  }}
                                  style={{
                                    maxWidth: "80%",
                                    overflow: "hidden",
                                  }}
                                  variant="standard"
                                  label="Servicios a prestar"
                                  placeholder=""
                                />
                              )}
                            />
                            <FormHelperText>
                              {this.state.errors.activitiesAppointment}
                            </FormHelperText>
                          </FormControl>
                        </Col>
                        {this.props.dataEvent.id_cita == "" ||
                        this.props.dataEvent.id_cita == undefined ||
                        this.props.dataEvent.id_cita == null ? (
                          <Col md={1}>
                            <Tooltip
                              style={
                                this.state.confirmedAdditionalAppointments
                                  .length > 0
                                  ? { color: "#fd7e14" }
                                  : null
                              }
                              title="Agregar mas Servicios con otro Profesional y otras Fechas"
                            >
                              <IconButton
                                aria-label="upload picture"
                                component="span"
                                onClick={() => {
                                  this.setState({
                                    openModalAdditionalAppointment: true,
                                  });
                                }}
                              >
                                <FontAwesomeIcon icon={faPlus} />
                              </IconButton>
                            </Tooltip>
                          </Col>
                        ) : null}
                      </>
                    ) : (
                      //Opciones de Cita por Patrocinador
                      <>
                        <Col md={3}>
                          <FormControl
                            className="medical-material-form__field"
                            InputLabelProps={{
                              style: { color: "#646777" },
                              shrink: true,
                            }}
                            style={{ width: "100%" }}
                            error={
                              this.state.errors.hasOwnProperty(
                                "estudio_clinico"
                              )
                                ? this.state.errors.estudio_clinico !== ""
                                : false
                            }
                          >
                            <InputLabel
                              shrink={true}
                              required
                              id="demo-simple-select-label"
                            >
                              Estudio Clinico
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={this.state.estudio_clinico}
                              onChange={(event) => {
                                this.handlerChangeClinicalStudio(
                                  event.target.value
                                );
                              }}
                              error={
                                this.state.errors.hasOwnProperty(
                                  "estudio_clinico"
                                )
                                  ? this.state.errors.estudio_clinico !== ""
                                  : false
                              }
                              disabled={this.props.dataEvent.id_cita != ""}
                            >
                              <MenuItem
                                className="material-form__option"
                                value={null}
                              >
                                Ninguno
                              </MenuItem>
                              {this.state.estudios_clinicos.map((estudio) => {
                                return (
                                  <MenuItem
                                    className="material-form__option"
                                    key={estudio.id_estudio}
                                    value={estudio}
                                  >
                                    {estudio.acronimo}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                            <FormHelperText>
                              {this.state.errors.estudio_clinico}
                            </FormHelperText>
                          </FormControl>
                        </Col>
                        <Col md={3}>
                          <FormControl
                            className="medical-material-form__field"
                            InputLabelProps={{
                              style: { color: "#646777" },
                              shrink: true,
                            }}
                            style={{
                              width: "100%",
                              position: "relative",
                              left: 10,
                            }}
                            error={
                              this.state.errors.hasOwnProperty("visita")
                                ? this.state.errors.visita !== ""
                                : false
                            }
                          >
                            <InputLabel
                              shrink={true}
                              required
                              id="demo-simple-select-label"
                            >
                              Visita
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={this.state.visita}
                              onChange={(event) => {
                                this.handlerChangeVisits(event.target.value);
                              }}
                              error={
                                this.state.errors.hasOwnProperty("visita")
                                  ? this.state.errors.visita !== ""
                                  : false
                              }
                              disabled={this.props.dataEvent.id_cita != ""}
                            >
                              <MenuItem
                                className="material-form__option"
                                value={null}
                              >
                                Ninguno
                              </MenuItem>
                              {this.state.visitas.map((visita) => {
                                return (
                                  <MenuItem
                                    className="material-form__option"
                                    key={visita.id_visita}
                                    value={visita}
                                  >
                                    {visita.nombre}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                            <FormHelperText>
                              {this.state.errors.visita}
                            </FormHelperText>
                          </FormControl>
                        </Col>
                      </>
                    )
                  }
                </Row>
              </div>

              {
                // exemptFromPayment --> verifica desde el backend si es excento de pago o no según el servicio, verifyPaymentServiceControl --> si es true las cobra
                this.state.exemptFromPayment == true ? (
                  <div
                    style={{
                      border: "1px solid #B2B8BF",
                      marginTop: 5,
                      borderRadius: 5,
                    }}
                  >
                    <div
                      id="formDivTercero"
                      style={{ margin: "1px 2px 1px 5px" }}
                    >
                      <div style={{ marginTop: 10, diplay: "flex" }}>
                        <h5 className="bold-text text-danger">
                          ADVERTENCIA: Este paciente tuvo una Consulta con
                          anterioridad en menos de{" "}
                          {this.state.numDaysToCheckPayment} dias
                          {this.state.verifyPaymentServiceControl
                            ? "."
                            : ", por lo que la Consulta de Control no generara cobro."}
                        </h5>
                      </div>
                    </div>
                  </div>
                ) : null
              }

              {
                //Formulario para Cita Medica de Tercero
                this.state.forma_cita == 1 ? (
                  <div
                    style={{
                      border: "1px solid #B2B8BF",
                      marginTop: 5,
                      borderRadius: 5,
                    }}
                  >
                    <div
                      id="formDivTercero"
                      style={{ margin: "1px 2px 1px 5px" }}
                    >
                      <Row className="row-default-space-modal-appointment">
                        <Col sm={12}>
                          <FormControl
                            component="fieldset"
                            error={
                              this.state.errors.hasOwnProperty("typeDate")
                                ? this.state.errors.typeDate !== ""
                                : false
                            }
                          >
                            <FormLabel component="legend">
                              Tipo de Cita
                            </FormLabel>
                            <RadioGroup
                              value={this.state.typeDate}
                              aria-label="tipo de cita"
                              name="customized-radios"
                              style={{ flexDirection: "row" }}
                              onChange={(e) => {
                                this.setState({ typeDate: e.target.value });
                              }}
                              error={
                                this.state.errors.hasOwnProperty("typeDate")
                                  ? this.state.errors.typeDate !== ""
                                  : false
                              }
                            >
                              <FormControlLabel
                                disabled={this.props.dataEvent.id_cita != ""}
                                value="Normal"
                                control={<StyledRadio />}
                                label="Normal"
                              />
                              <FormControlLabel
                                disabled={this.props.dataEvent.id_cita != ""}
                                value="Control Programada"
                                control={<StyledRadio />}
                                label="Control Programada"
                              />
                              <FormControlLabel
                                disabled={this.props.dataEvent.id_cita != ""}
                                value="Discrecional"
                                control={<StyledRadio />}
                                label="Discrecional"
                              />
                            </RadioGroup>
                            <FormHelperText>
                              {this.state.errors.typeDate}
                            </FormHelperText>
                          </FormControl>
                        </Col>
                      </Row>
                      <Row className="row-default-space-modal-appointment">
                        <Col sm={4} xs={12}>
                          <MuiPickersUtilsProvider utils={MomentUtils}>
                            <ThemeProvider theme={defaultMaterialTheme}>
                              <DatePicker
                                className="medical-material-form__field"
                                InputLabelProps={{
                                  style: { color: "#646777" },
                                  shrink: true,
                                }}
                                variant="inline"
                                label="Fecha Deseada de Cita"
                                disabled={this.props.dataEvent.id_cita != ""}
                                views={["year", "month", "date"]}
                                value={this.state.possibleDate}
                                onChange={(date) => {
                                  this.handlerPossilbledate(date);
                                }}
                                animateYearScrolling
                                format="yyyy/MM/DD"
                                error={
                                  this.state.errors.hasOwnProperty(
                                    "possibleDate"
                                  )
                                    ? this.state.errors.possibleDate !== ""
                                    : false
                                }
                                helperText={this.state.errors.possibleDate}
                                autoOk={true}
                                InputProps={{
                                  classes: {
                                    disabled: classes.disabled,
                                  },
                                }}
                              />
                            </ThemeProvider>
                          </MuiPickersUtilsProvider>
                        </Col>
                        <Col sm={4} xs={12}>
                          <FormControl component="fieldset">
                            <FormLabel component="legend">
                              Primera vez
                            </FormLabel>
                            <RadioGroup
                              value={this.state.firstAppointment}
                              onChange={(e) => {
                                this.setState({
                                  firstAppointment: e.target.value,
                                });
                              }}
                              aria-label="tipo de cita"
                              name="customized-radios"
                              style={{ flexDirection: "row" }}
                            >
                              <FormControlLabel
                                disabled={this.props.dataEvent.id_cita != ""}
                                value="Si"
                                control={<StyledRadio />}
                                label="Si"
                              />
                              <FormControlLabel
                                disabled={this.props.dataEvent.id_cita != ""}
                                value="No"
                                control={<StyledRadio />}
                                label="No"
                              />
                            </RadioGroup>
                          </FormControl>
                        </Col>
                        <Col sm={4} xs={12}>
                          <FormControl
                            className="medical-material-form__field"
                            InputLabelProps={{
                              style: { color: "#646777" },
                              shrink: true,
                            }}
                            disabled={this.props.dataEvent.id_cita !== ""}
                            error={
                              this.state.errors.hasOwnProperty("typeConsult")
                                ? this.state.errors.typeConsult !== ""
                                : false
                            }
                          >
                            <InputLabel
                              shrink={true}
                              required
                              id="demo-simple-select-label"
                            >
                              Finalidad de la Cita
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="id-simple-select"
                              value={this.state.typeConsult}
                              onChange={(event) => {
                                this.setState({
                                  typeConsult: event.target.value,
                                });
                              }}
                            >
                              {this.state.tiposConsulta.map(
                                (tipoConsulta) =>
                                  // En el futuro cambiar el tipo de usuario por el codigo
                                  tipoConsulta.estado === "A" && (
                                    <MenuItem
                                      key={tipoConsulta.id_tipo_consulta}
                                      value={tipoConsulta}
                                    >
                                      {tipoConsulta.nombre}
                                    </MenuItem>
                                  )
                              )}
                              {/* <MenuItem className="material-form__option" key={1} value={'01'}>ATENCION DEL PARTO (PUERPERIO)</MenuItem>
                                                            <MenuItem className="material-form__option" key={2} value={'02'}>ATENCION DEL RECIEN NACIDO</MenuItem>
                                                            <MenuItem className="material-form__option" key={3} value={'03'}>ATENCION EN PLANIFICACION FAMILIAR</MenuItem>
                                                            <MenuItem className="material-form__option" key={4} value={'04'}>DETECCION DE ALTERACIONES DE CRECIMIENTO Y DESARROLLO DEL MENOR DE DIEZ AÑOS</MenuItem>
                                                            <MenuItem className="material-form__option" key={5} value={'05'}>DETECCION DE ALTERACION DEL DESARROLLO JOVEN</MenuItem>
                                                            <MenuItem className="material-form__option" key={6} value={'06'}>DETECCION DE ALTERACIONES DEL EMBARAZO</MenuItem>
                                                            <MenuItem className="material-form__option" key={7} value={'07'}>DETECCION DE ALTERACIONES DEL ADULTO</MenuItem>
                                                            <MenuItem className="material-form__option" key={8} value={'08'}>DETECCION DE ALTERACIONES DE AGUDEZA VISUAL</MenuItem>
                                                            <MenuItem className="material-form__option" key={9} value={'09'}>DETECCION DE ENFERMEDAD PROFESIONAL</MenuItem>
                                                            <MenuItem className="material-form__option" key={10} value={'10'}>NO APLICA</MenuItem> */}
                            </Select>
                            <FormHelperText>
                              {this.state.errors.typeConsult}
                            </FormHelperText>
                          </FormControl>
                        </Col>
                      </Row>
                    </div>
                  </div>
                ) : null
              }
            </div>
            <div
              className="flex-row"
              style={{ width: "100%", padding: "1em 0.5em" }}
            >
              <div style={{ width: "100%" }}>
                <TextField
                  className="medical-material-form__field"
                  InputLabelProps={{
                    style: { color: "#646777" },
                    shrink: true,
                  }}
                  id="standard-multiline-flexible"
                  label="Observaciones"
                  multiline
                  rowsMax={4}
                  disabled={
                    this.props.dataEvent.id_cita !== "" &&
                    this.state.observationFieldEdit === false
                  }
                  value={this.state.observation}
                  onChange={(event) => {
                    this.handlerObservation(event);
                  }}
                  style={{ flex: 1, width: "100%", marginTop: 5 }}
                />
              </div>
              {this.props.dataEvent.id_cita !== "" ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  {this.state.observationFieldEdit === false ? (
                    <Tooltip title="Editar observacion">
                      <IconButton
                        aria-label="upload picture"
                        component="span"
                        className="icon-button-agenda-modal"
                        onClick={() => {
                          this.setState({ observationFieldEdit: true });
                        }}
                      >
                        <EditOutlinedIcon fontSize="medium" />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <>
                      <Tooltip title="Actualizar " style={{ margin: "0.25em" }}>
                        <IconButton
                          aria-label="upload picture"
                          component="span"
                          className="icon-button-agenda-modal"
                          onClick={() => {
                            this.updateObservation(
                              this.props.dataEvent.id_cita
                            );
                          }}
                        >
                          <SaveIcon fontSize="medium" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip
                        title="Cancelar Edición"
                        style={{ margin: "0.25em" }}
                      >
                        <IconButton
                          aria-label="upload picture"
                          component="span"
                          className="icon-button-agenda-modal"
                          onClick={() => {
                            this.setState({ observationFieldEdit: false });
                          }}
                        >
                          <BlockIcon fontSize="medium" />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                </div>
              ) : null}
            </div>
            {this.state.appointmentExist && !!this.state.appointsmentsDate ? (
              <div style={{ margin: "0.25em 0em", color: "#153365" }}>
                <div>
                  <h5>
                    FECHA Y USUARIO DE ASIGNACIÓN:{" "}
                    <b>
                      {moment(this.state.appointsmentsDate)
                        .format("DD-MMMM-YYYY h:mm a")
                        .toUpperCase()}{" "}
                      - {this.state.userAppoint}
                    </b>
                  </h5>
                </div>
              </div>
            ) : null}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                marginTop: 10,
                justifyContent: "flex-end",
              }}
            >
              <Button
                style={{ marginRight: 10, marginLeft: 10 }}
                variant="contained"
                onClick={() => {
                  this.props.handlerClose(false);
                  this.props.reload(
                    this.props.selectedDay,
                    this.props.professional,
                    this.props.typeAppointment,
                    this.props.atentionAgenda
                  );
                }}
              >
                Cerrar
              </Button>

              {this.state.priority === "Incumplida" ||
              this.state.priority === "Disponible" ||
              this.state.priority === "Reservada" ? (
                this.state.showSpecialReq ? (
                  <Fragment>
                    <Button
                      style={{ marginRight: 10, marginLeft: 10, float: "left" }}
                      color="primary"
                      variant="contained"
                      onClick={() => {
                        this.setState({ modalReqEsp: true });
                      }}
                    >
                      Req. Especiales*
                    </Button>
                  </Fragment>
                ) : null
              ) : null}
              {this.state.priority === "Incumplida" ||
              this.state.priority === "Disponible" ||
              this.state.priority === "Reservada" ? (
                this.state.showFallingRisks ? (
                  <Fragment>
                    <Button
                      style={{ marginRight: 10, marginLeft: 10, float: "left" }}
                      color="primary"
                      variant="contained"
                      onClick={() => {
                        this.setState({ modalFallingRisks: true });
                      }}
                    >
                      Riesgo de caida*
                    </Button>
                  </Fragment>
                ) : null
              ) : null}
              {this.state.priority === "Reservada" ||
              this.state.priority === "Incumplida" ? ( //Reservada
                <Fragment>
                  <Button
                    style={{ marginRight: 10, marginLeft: 10 }}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      this.setState({ openCancel: true });
                    }}
                  >
                    Cancelar
                  </Button>
                </Fragment>
              ) : null}
              {this.state.priority === "Disponible" ? (
                <Button
                  style={{ marginRight: 10, marginLeft: 10 }}
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    this.disableAppointment();
                  }}
                >
                  Inactivar
                </Button>
              ) : null}
              {this.state.priority === "Inactiva" ? (
                <Button
                  style={{ marginRight: 10, marginLeft: 10 }}
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    this.enableAppointment();
                  }}
                >
                  Activar
                </Button>
              ) : null}
              {this.state.priority !== "Incumplida" ? (
                this.state.id_appointment === "" ? (
                  <>
                    {this.state.loadingProcess == true ? (
                      <Spinner animation="border" variant="success" />
                    ) : (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          this.sendAsign();
                        }}
                      >
                        Asignar
                      </Button>
                    )}
                  </>
                ) : this.state.id_appointment !== null &&
                  (this.state.priority === "Cumplida" ||
                    this.state.priority === "Emergencia") ? (
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={
                      this.state.costumer_data !== null &&
                      this.state.costumer_data !== undefined
                        ? false
                        : true
                    }
                    onClick={() => {
                      this.sendDataAdmission();
                    }}
                  >
                    Ver Admisión
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={
                      this.state.costumer_data !== null &&
                      this.state.costumer_data !== undefined
                        ? false
                        : true
                    }
                    onClick={() => {
                      this.sendDataAdmission();
                    }}
                  >
                    Admitir
                  </Button>
                )
              ) : null}
            </div>
          </Row>
        </Modal>
        {this.state.modalFallingRisks ? (
          <FallingRisksModal
            openRisk={this.state.modalFallingRisks}
            dataCaidaSet={this.dataCaidaSet}
            caidaData={{ caidas: this.state.caidas }}
            closeOpenRisk={() => {
              this.setState({ modalFallingRisks: false });
            }}
          />
        ) : null}

        {this.state.modalReqEsp ? (
          <EspecialRequirementsModal
            openEspReq={this.state.modalReqEsp}
            reqEspData={{
              requerimientos_especiales: this.state.requerimientos_especiales,
            }}
            dataReqEsp={this.dataReqEsp}
            closeEspReq={() => {
              this.setState({ modalReqEsp: false });
            }}
          />
        ) : null}
        {this.state.openModalAlergies &&
        (this.state.patienteExist || this.props.dataEvent.id_cita !== "") ? (
          <AlergiesListToShow
            id_historia={this.props.dataEvent.id_historia}
            openModaAlergie={this.state.openModalAlergies}
            handlerOpenModalAlergies={this.handlerOpenModalAlergies}
          />
        ) : null}
        {this.state.openCancel ? (
          <Modal
            open={this.state.openCancel}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ zIndex: 1000 }}
          >
            <div
              className="paperAppointment-flex"
              style={{ width: "100%", margin: 10 }}
            >
              <h4 className="bold-text">Cancelar Cita</h4>
              <FormControl
                className="medical-material-form__field"
                InputLabelProps={{
                  style: { color: "#646777" },
                  shrink: true,
                }}
                style={{ width: 200, marginBottom: 20 }}
              >
                <InputLabel
                  shrink={true}
                  required
                  id="demo-simple-select-label"
                >
                  Tipo de Cancelación
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="id-simple-select"
                  defaultValue={null}
                  value={this.state.cancelType}
                  onChange={(event) => {
                    this.setState({ cancelType: event.target.value });
                  }}
                >
                  <MenuItem key={0} value={1}>
                    Doctor Ausente
                  </MenuItem>
                  <MenuItem key={1} value={2}>
                    Motivos Personales
                  </MenuItem>
                  <MenuItem key={1} value={3}>
                    Otros
                  </MenuItem>
                </Select>
              </FormControl>

              <div className="form">
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    Motivo de Cancelacion
                  </span>
                  <div className="form__form-group-field">
                    <textarea
                      name="textarea-cancel"
                      onChange={(e) => {
                        this.setState({ cancelObservation: e.target.value });
                      }}
                    ></textarea>
                  </div>
                </div>
              </div>

              <div
                style={{
                  marginTop: 10,
                  display: "flex",
                  marginTop: 10,
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  style={{ marginRight: 10, marginLeft: 10 }}
                  variant="contained"
                  onClick={() => {
                    this.props.handlerClose(false);
                  }}
                >
                  Cerrar
                </Button>

                <Button
                  style={{ marginRight: 10, marginLeft: 10 }}
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    this.cancelAppointment();
                  }}
                >
                  Cancelar
                </Button>
              </div>
            </div>
          </Modal>
        ) : null}

        <ModalAdditionalAppointment
          openModalAdditionalAppointment={
            this.state.openModalAdditionalAppointment
          }
          closeModal={() => {
            this.setState({ openModalAdditionalAppointment: false });
          }}
          activitiesPriceList={this.state.activitiesPriceList}
          activitiesAppointment={this.state.activitiesAppointment}
          date={this.state.date}
          handlerConfirmedAdditionalAppointments={
            this.handlerConfirmedAdditionalAppointments
          }
          confirmedAdditionalAppointments={
            this.state.confirmedAdditionalAppointments
          }
          serter={this.state.serter.filter((ser) => ser.tipo != 2)}
          completeHandlerConfirmedAddionalAppointments={
            this.completeHandlerConfirmedAddionalAppointments
          }
          actualAppointmentClient={this.state.costumer_data}
          actualAppointmentPlan={this.state.plan}
          actualAppointmentPlanDetails={this.state.plans.find(
            (pl) => pl.id_plan == this.state.plan
          )}
          nameInitialPhase={this.state.nameInitialPhase}
          changeNameInitialPhase={this.changeNameInitialPhase}
          id_historia={this.state.history}
        />

        <ModalChangeAppointmentDate
          openModalChangingAppointment={this.state.openModalChangingAppointment}
          handlerCloseOpenModalChangingAppointment={
            this.handlerCloseOpenModalChangingAppointment
          }
          date={this.state.date}
          professionals={this.state.professionals}
          professional={this.state.professional}
          refreshOriginalDates={this.refreshOriginalDates}
          handlerDate={this.handlerDate}
          handlerProfessional={this.handlerProfessional}
          atentionAgenda={this.props.atentionAgenda}
          alertModal={this.alertModal}
          activitiesAppointment={this.state.activitiesAppointment}
          serviceChangeDate={this.state.serviceChangeDate}
          handlerServiceChangeDate={this.handlerServiceChangeDate}
          reloadAgenda={() => {
            this.setState({ openModalChangingAppointment: false });
            this.props.reload(
              this.props.selectedDay,
              this.props.professional,
              this.props.typeAppointment,
              this.props.atentionAgenda
            );
            this.props.handlerClose(false);
          }}
          dataEvent={this.props.dataEvent}
          id_historia={this.state.history}
        />

        <ModalSelectRoom
          open={this.state.isModalOpenRoom}
          onClose={this.handleCloseModal}
          room={this.state.room}
          onSave={this.handleRoomSave}
        />
      </React.Fragment>
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  AppointmentAssignmentModal
);
